// src/components/PackingListEditorPFS.js

import React, { useState, useEffect, useMemo } from 'react';
import {
  Card, Form, Button, Table, Input, InputNumber, Space, Select, Tooltip,
  Typography, Divider, Row, Col, Popconfirm, message, Tabs, Spin, Tag,
  Progress, Affix, Modal, List, Image, Descriptions, Alert,Collapse
} from 'antd';
import {
  PlusOutlined, DeleteOutlined, SaveOutlined, CheckOutlined, CloseOutlined,
  PrinterOutlined, ArrowLeftOutlined, PercentageOutlined, CameraOutlined, EyeOutlined,
  CloudUploadOutlined, AppstoreAddOutlined, DownOutlined, RightOutlined, ProfileOutlined,
  FilePdfOutlined, EditOutlined
} from '@ant-design/icons';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import PhotoCaptureQR from './PhotoCaptureQR';
import { catalogService, deliveryService, settingsService } from '../services/api';
import { useAuth } from '../context/AuthContext';
const { Title, Text } = Typography;
const { Option } = Select;
const { Panel } = Collapse;


//HELPER PARA BUSCAR LAS CLASIFICACIONES
const getItemPFSType = (itemCode) => {
  if (!itemCode) return null;
  const upperCode = itemCode.toUpperCase();
  if (upperCode.startsWith("MON")) return 'monin';
  if (upperCode.startsWith("RAT")) return 'pastilla';
  if (upperCode.startsWith("BEW")) return 'capsula';
  return 'otro'; // Para ICB, BUN001, etc.
};
// +++ FIN: NUEVA FUNCIÓN HELPER +++

// +++ INICIO: HELPER MEJORADO PARA SUBCLASIFICACIÓN BEW +++
const getBewSubClass = (description) => {
  if (!description) return 'accesorio_bew';
  const upper = description.toUpperCase();

  // 1. CÁPSULAS: Prioridad Alta
  if (upper.includes('CAPSULA')) return 'capsula';

  // 2. EXCEPCIONES (Refacciones que pueden decir "SIFON" en su nombre)
  // Si encontramos estas palabras, es un accesorio AUTOMÁTICAMENTE, ignorando si dice Sifón o Aluminio después.
  const palabrasClaveAccesorios = [
      'BOTELLA', 'CABEZAL', 'CEPILLO', 'DUYA', 'EMPAQUE', 
      'PORTA', 'KIT', 'REFACCION', 'TAPA', 'TUBO', 'CARGADOR'
  ];
  
  // .some() revisa si alguna de las palabras clave está en la descripción
  if (palabrasClaveAccesorios.some(palabra => upper.includes(palabra))) {
      return 'accesorio_bew';
  }

  // 3. SIFONES (EQUIPOS): Ahora sí, si dice SIFON y no cayó arriba, es un equipo.
  if (upper.includes('SIFON')) {
    const isAlu = upper.includes('ALUMINIO') || upper.includes('ALU');
    const isAcero = upper.includes('ACERO') || upper.includes('INOX');
    
    // Detección de tamaño
    const is1L = upper.includes('1 L') || upper.includes('1.0 L') || upper.includes('1L'); 
    const is500 = upper.includes('500 ML') || upper.includes('0.5') || upper.includes('500ML');

    if (isAlu) {
       if (is1L) return 'sifon_alu_1l';
       if (is500) return 'sifon_alu_500';
       return 'sifon_alu_1l'; // Default
    }
    if (isAcero) {
       if (is1L) return 'sifon_acero_1l';
       if (is500) return 'sifon_acero_500';
       return 'sifon_acero_1l'; // Default
    }
    // Si dice SIFON pero no tiene material, lo mandamos a accesorio por seguridad
    return 'accesorio_bew';
  }

  // 4. ACCESORIOS: Todo lo demás
  return 'accesorio_bew';
};
// +++ FIN: HELPER MEJORADO +++

// Componentes y funciones de ayuda (sin cambios)
const SuccessAnimation = ({ folio, onClose }) => { useEffect(() => { const timer = setTimeout(() => { if (onClose) onClose(); }, 3000); return () => clearTimeout(timer); }, [onClose]); return (<div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999 }}> <div style={{ backgroundColor: 'white', borderRadius: '50%', width: '320px', height: '320px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(0,0,0,0.15)', padding: 0, overflow: 'hidden' }}> <div style={{ backgroundColor: '#52c41a', borderRadius: '50%', width: '80px', height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 0 20px 0', flexShrink: 0 }}> <CheckOutlined style={{ fontSize: '50px', color: 'white' }} /> </div> <Typography.Title level={3} style={{ margin: '5px 0', textAlign: 'center' }}>¡Guardado Exitoso!</Typography.Title> <div style={{ textAlign: 'center' }}> <Typography.Text style={{ fontSize: '14px', display: 'block' }}>Listado de Empaque</Typography.Text> <Typography.Text strong style={{ fontSize: '16px', color: '#52c41a', display: 'block' }}>{folio}</Typography.Text> <Typography.Text style={{ fontSize: '14px', display: 'block', marginTop: '5px' }}>guardado correctamente</Typography.Text> </div> </div> </div>); };
const ErrorAnimation = ({ percent, onClose }) => { useEffect(() => { const timer = setTimeout(() => { if (onClose) onClose(); }, 3500); return () => clearTimeout(timer); }, [onClose]); return (<div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999 }}> <div style={{ backgroundColor: 'white', borderRadius: '50%', width: '320px', height: '320px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(0,0,0,0.15)', padding: 0, overflow: 'hidden' }}> <div style={{ backgroundColor: '#ff4d4f', borderRadius: '50%', width: '80px', height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 0 20px 0', flexShrink: 0 }}> <CloseOutlined style={{ fontSize: '50px', color: 'white' }} /> </div> <Typography.Title level={3} style={{ margin: '5px 0', textAlign: 'center', color: '#ff4d4f' }}> ¡Empaque Incompleto! </Typography.Title> <div style={{ textAlign: 'center', padding: '0 20px' }}> <Typography.Text style={{ fontSize: '14px', display: 'block' }}> El listado de empaque solo está al </Typography.Text> <Typography.Text strong style={{ fontSize: '16px', color: '#ff4d4f', display: 'block' }}> {percent}% </Typography.Text> <Typography.Text style={{ fontSize: '14px', display: 'block', marginTop: '5px' }}> Por favor, complete las cantidades para poder guardar. </Typography.Text> </div> </div> </div>); };

const getMoninSubClassification = (itemDescription) => { if (!itemDescription) return '1L'; const upperDesc = itemDescription.toUpperCase(); if (upperDesc.includes("750")) return '750ml'; if (upperDesc.includes("1.89")) return '1.89L'; return '1L'; };
const getPastillaSubClass = (description) => { const upperDesc = (description || '').toUpperCase(); if (upperDesc.includes('ACTIVEGREEN') || upperDesc.includes('ACTIVE GREEN')) { return 'ActiveGreen'; } if (upperDesc.includes('PREVENTIVA')) { return 'Preventiva'; } if (upperDesc.includes('DETERGENTE')) { return 'Detergente'; } return null; };



const calculatePalletPfsTotalsForPayload = (pallet, deliveryData, itemMasterData, globalPfsClassification, itemSubClassMap) => {
  // 1. Inicializamos TODOS los contadores (Viejos y Nuevos)
  const defaultTotals = {
      totalBotellas750ml: 0, totalCajas750ml: 0, totalBotellas1L: 0, totalCajas1L: 0, 
      totalBotellas1_89L: 0, totalCajas1_89L: 0, totalCubetasPreventivas: 0, 
      totalCubetasDetergentes: 0, totalCubetasActiveGreen: 0, 
      
      // Capsulas Originales
      totalCapsulas: 0, totalCajasCapsulas: 0,

      // +++ NUEVOS CAMPOS BEW +++
      totalSifonesAluminio1L: 0, totalSifonesAluminio500: 0,
      totalSifonesAcero1L: 0, totalSifonesAcero500: 0,
      totalAccesoriosBew: 0,

      totalInsumosVarios: 0 // Para items 'OTRO' (Genéricos)
  };

  if (!pallet || !deliveryData || !itemMasterData) return defaultTotals;
  const palletTotals = { ...defaultTotals };

  pallet.levels.forEach(level => {
    level.items.forEach(packedItem => {
      const type = getItemPFSType(packedItem.itemCode);
      const quantity = packedItem.quantity || 0;

      // --- BLOQUE MONIN ---
      if (type === 'monin' && packedItem.lineNum !== null) {
        const originalDocLine = deliveryData.DocumentLines.find(line => line.LineNum === packedItem.lineNum && line.ItemCode === packedItem.itemCode);
        if (originalDocLine) {
          const moninSubClass = getMoninSubClassification(originalDocLine.ItemDescription || originalDocLine.ItemName);
          const purchaseItemsPerUnit = itemMasterData[packedItem.itemCode]?.PurchaseItemsPerUnit;
          if (moninSubClass === '750ml') {
            palletTotals.totalBotellas750ml += quantity;
            if (purchaseItemsPerUnit > 0) palletTotals.totalCajas750ml += (quantity / purchaseItemsPerUnit);
          } else if (moninSubClass === '1.89L') {
            palletTotals.totalBotellas1_89L += quantity;
            if (purchaseItemsPerUnit > 0) palletTotals.totalCajas1_89L += (quantity / purchaseItemsPerUnit);
          } else {
            palletTotals.totalBotellas1L += quantity;
            if (purchaseItemsPerUnit > 0) palletTotals.totalCajas1L += (quantity / purchaseItemsPerUnit);
          }
        }
      } 
      // --- BLOQUE PASTILLA ---
      else if (type === 'pastilla') {
        const subClass = itemSubClassMap[packedItem.itemCode];
        if (subClass === 'ActiveGreen') palletTotals.totalCubetasActiveGreen += quantity;
        else if (subClass === 'Preventiva') palletTotals.totalCubetasPreventivas += quantity;
        else if (subClass === 'Detergente') palletTotals.totalCubetasDetergentes += quantity;
      } 
      // --- BLOQUE CAPSULA (BEW) - ACTUALIZADO ---
      else if (type === 'capsula' && packedItem.lineNum !== null) {
        // Obtenemos descripción original para subclasificar con precisión
        const originalDocLine = deliveryData.DocumentLines.find(line => line.LineNum === packedItem.lineNum && line.ItemCode === packedItem.itemCode);
        const description = originalDocLine ? (originalDocLine.ItemDescription || originalDocLine.ItemName) : packedItem.description;
        
        // Usamos el nuevo Helper
        const bewSubClass = getBewSubClass(description);

        if (bewSubClass === 'capsula') {
            // Lógica original de Cajas y Piezas
            palletTotals.totalCapsulas += quantity;
            const purchaseItemsPerUnit = itemMasterData[packedItem.itemCode]?.PurchaseItemsPerUnit;
            if (purchaseItemsPerUnit > 0) palletTotals.totalCajasCapsulas += (quantity / purchaseItemsPerUnit);
        } 
        else if (bewSubClass === 'sifon_alu_1l') palletTotals.totalSifonesAluminio1L += quantity;
        else if (bewSubClass === 'sifon_alu_500') palletTotals.totalSifonesAluminio500 += quantity;
        else if (bewSubClass === 'sifon_acero_1l') palletTotals.totalSifonesAcero1L += quantity;
        else if (bewSubClass === 'sifon_acero_500') palletTotals.totalSifonesAcero500 += quantity;
        else {
            // Caso 'accesorio_bew'
            palletTotals.totalAccesoriosBew += quantity;
        }
      } 
      // --- BLOQUE OTROS (Genéricos) ---
      else {
        palletTotals.totalInsumosVarios += quantity;
      }
    });
  });

  // Redondeos necesarios para PDF
  palletTotals.totalCajas750ml = parseFloat(palletTotals.totalCajas750ml.toFixed(2));
  palletTotals.totalCajas1L = parseFloat(palletTotals.totalCajas1L.toFixed(2));
  palletTotals.totalCajas1_89L = parseFloat(palletTotals.totalCajas1_89L.toFixed(2));
  palletTotals.totalCajasCapsulas = parseFloat(palletTotals.totalCajasCapsulas.toFixed(2));

  return palletTotals;
};



const PackingListEditorPFS = ({ docEntry: docEntryFromProp, onBack: onBackFromProp }) => {
  const { user } = useAuth();
  const { docEntry: docEntryFromUrl } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const docEntry = docEntryFromUrl || docEntryFromProp;
  const packingListId = location.state?.packingListId;
  const isReadOnly = location.state?.readOnly || false;

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [printLoading, setPrintLoading] = useState(false);
  const [reportByPalletLoading, setReportByPalletLoading] = useState(false);
  const [deliveryData, setDeliveryData] = useState(null);
  const [pallets, setPallets] = useState([]);
  const [form] = Form.useForm();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [savedFolio, setSavedFolio] = useState(null);
  const [showErrorModal, setShowErrorModal] = useState(false);//nuevo
  const [incompletePercent, setIncompletePercent] = useState(0);//nuevo
  const [photoQrVisible, setPhotoQrVisible] = useState(false);
  const [evidenceImages, setEvidenceImages] = useState([]);

  const [uploadProgressVisible, setUploadProgressVisible] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [totalImagesToUpload, setTotalImagesToUpload] = useState(0);
  const [currentImageProgress, setCurrentImageProgress] = useState(0);
  const [uploadStatus, setUploadStatus] = useState('');

  const [itemMasterData, setItemMasterData] = useState({});
  const [saveValidationAlert, setSaveValidationAlert] = useState(null);
  const [pdfErrorAlert, setPdfErrorAlert] = useState(null); // Estado para errores de PDF

  const [activePalletDefinitions, setActivePalletDefinitions] = useState([]);
  const [catalogLoading, setCatalogLoading] = useState(false);

  const [itemSubClassMap, setItemSubClassMap] = useState({});

  // +++ INICIO: NUEVO ESTADO +++
  // Guarda los tipos de PFS que se detectan en la entrega
  const [tiposDisponibles, setTiposDisponibles] = useState({
    monin: false,
    pastilla: false,
    capsula: false,
  });
  // +++ FIN: NUEVO ESTADO +++


  const [pfsTotals, setPfsTotals] = useState({
    classification: null,
    totalBotellas750ml: 0, totalBotellas1L: 0, totalBotellas1_89L: 0,
    totalCajas750ml: 0, totalCajas1L: 0, totalCajas1_89L: 0,
    totalCubetasPreventivas: 0, totalCubetasDetergentes: 0, totalCubetasActiveGreen: 0,
    totalCapsulas: 0, totalCajasCapsulas: 0,
  });

  // +++ INICIO: NUEVOS ESTADOS PARA EL MODAL DE DIMENSIONES MANUALES +++
  const [isManualDimModalVisible, setIsManualDimModalVisible] = useState(false);
  const [editingPalletIndex, setEditingPalletIndex] = useState(null);
  const [manualDimForm] = Form.useForm();
  const [mixConflict, setMixConflict] = useState({ visible: false, current: '', intent: '' });
  // +++ FIN: NUEVOS ESTADOS +++

  const [minPhotosRequired, setMinPhotosRequired] = useState(6); // Default seguro
  
  const permissions = useMemo(() => {
    const isOpen = deliveryData?.DocumentStatus === 'bost_Open';
    const statusKey = isOpen ? 'onOpen' : 'onClosed';
    const statusPerms = user?.role?.profile?.permissions?.actions?.packingListEditorPfs?.[statusKey];

    if (!statusPerms) {
      return {
        canSaveOrEdit: false,
        canModifyContent: false,
        canManageEvidenceOnCreate: false,
        canManageEvidenceOnEdit: false,
        canViewEvidence: false,
        canDeleteEvidence: false, // +++ Se añade el nuevo permiso
        canGeneratePdf: false,
      };
    }

    const isEditMode = !!(deliveryData?.packingList?.packingListNumber && deliveryData?.packingList?.formato === 'B');
    const canSaveOrEdit = isEditMode ? statusPerms.canEdit : statusPerms.canCreate;

    return {
      canSaveOrEdit: canSaveOrEdit,
      canModifyContent: canSaveOrEdit,
      canManageEvidenceOnCreate: statusPerms.canManageEvidenceOnCreate,
      canManageEvidenceOnEdit: statusPerms.canManageEvidenceOnEdit,
      canViewEvidence: statusPerms.canViewEvidence,
      canDeleteEvidence: statusPerms.canDeleteEvidence, // +++ Se lee el nuevo permiso
      canGeneratePdf: statusPerms.canGeneratePdf,
    };
  }, [deliveryData, user]);

  const canEditContent = !isReadOnly && permissions.canModifyContent;
  const canManageEvidence = !isReadOnly && (!!(deliveryData?.packingList?.packingListNumber && deliveryData?.packingList?.formato === 'B') ? permissions.canManageEvidenceOnEdit : permissions.canManageEvidenceOnCreate);



  useEffect(() => {
    const loadConfig = async () => {
        try {
            const res = await settingsService.getSetting('minPhotosPerList');
            if (res.data.success && typeof res.data.data.value === 'number') {
                setMinPhotosRequired(res.data.data.value);
            }
        } catch (e) {
            console.warn("No se pudo cargar config de fotos mínimas, usando default 6");
        }
    };
    loadConfig();
}, []);
// +++ FIN EFECTO +++
  useEffect(() => {
    if (docEntry) { fetchDeliveryDetails(true); }
    else { setLoading(false); message.warning("No se pudo determinar el DocEntry para cargar los datos."); }
  }, [docEntry, packingListId]);

  useEffect(() => {
    if (deliveryData && deliveryData.DocumentLines) {
      const newMap = {};
      deliveryData.DocumentLines.forEach(line => {
        const subClass = getPastillaSubClass(line.ItemDescription || line.ItemName);
        if (subClass) {
          newMap[line.ItemCode] = subClass;
        }
      });
      setItemSubClassMap(newMap);
    }
  }, [deliveryData]);

  useEffect(() => {
    const fetchActivePalletDefs = async () => {
      setCatalogLoading(true);
      try {
        const response = await catalogService.getPalletDefinitions();
        if (response.data.success) {

          setActivePalletDefinitions(response.data.data || []);
        } else {
          message.error('Error al cargar catálogo de dimensiones de tarimas: ' + (response.data.message || 'Error desconocido'));
          setActivePalletDefinitions([]);
        }
      } catch (error) {
        console.error(" Editor B: Error fetching pallet definitions:", error);
        setActivePalletDefinitions([]);
      } finally {
        setCatalogLoading(false);
      }
    };
    fetchActivePalletDefs();
  }, []);

// --------------------------------------------------------------------------
  // USE EFFECT MAESTRO: DETECCIÓN DE TIPOS, CLASIFICACIÓN Y CÁLCULO DE TOTALES
  // --------------------------------------------------------------------------
  useEffect(() => {
    // 1. Definir Totales Iniciales (Vacíos)
// 1. Definir Totales Iniciales (Vacíos) - CORREGIDO
    const initialTotalsState = {
        classification: null, 
        totalBotellas750ml: 0, totalCajas750ml: 0, totalBotellas1L: 0, totalCajas1L: 0, 
        totalBotellas1_89L: 0, totalCajas1_89L: 0,
        totalCubetasPreventivas: 0, totalCubetasDetergentes: 0, totalCubetasActiveGreen: 0,
        totalCapsulas: 0, totalCajasCapsulas: 0,
        
        // --- AGREGAMOS LAS VARIABLES QUE FALTABAN ---
        totalSifonesAluminio1L: 0, totalSifonesAluminio500: 0,
        totalSifonesAcero1L: 0, totalSifonesAcero500: 0,
        totalAccesoriosBew: 0,
        // --------------------------------------------
        
        totalInsumosVarios: 0 
    };

    if (!deliveryData || !deliveryData.DocumentLines) {
        if (JSON.stringify(pfsTotals) !== JSON.stringify(initialTotalsState)) {
            setPfsTotals(initialTotalsState);
        }
        return;
    }

    // 2. DETECCIÓN DE TIPOS (Monin, Pastilla, Capsula)
    // Esto alimenta tanto a los BOTONES como a la CLASIFICACIÓN
    let hasMonin = false, hasPastilla = false, hasCapsula = false;
    
    deliveryData.DocumentLines.forEach(line => {
        const type = getItemPFSType(line.ItemCode);
        if (type === 'monin') hasMonin = true;
        if (type === 'pastilla') hasPastilla = true;
        if (type === 'capsula') hasCapsula = true;
    });

    // ¡ACTUALIZAMOS LOS BOTONES AQUÍ MISMO PARA QUE NO FALLEN!
    setTiposDisponibles({ monin: hasMonin, pastilla: hasPastilla, capsula: hasCapsula });

    // 3. DETERMINAR CLASIFICACIÓN (Si no viene guardada)
    let determinedClassification = pfsTotals.classification;
    if (!determinedClassification) {
        const tiposEncontrados = (hasMonin ? 1 : 0) + (hasPastilla ? 1 : 0) + (hasCapsula ? 1 : 0);
        
        if (tiposEncontrados > 1) determinedClassification = 'combinado';
        else if (hasMonin) determinedClassification = 'monin';
        else if (hasPastilla) determinedClassification = 'pastilla';
        else if (hasCapsula) determinedClassification = 'capsula';
    }

    // 4. CALCULAR TOTALES (Suma en vivo)
    const newCalculatedTotals = { ...initialTotalsState, classification: determinedClassification };

    pallets.forEach(pallet => {
      pallet.levels.forEach(level => {
        level.items.forEach(packedItem => {
          const type = getItemPFSType(packedItem.itemCode);
          if (!type) return;
          const quantity = parseInt(packedItem.quantity, 10) || 0;

          if (type === 'monin' && packedItem.lineNum !== null) {
              const originalDocLine = deliveryData.DocumentLines.find(line => line.LineNum === packedItem.lineNum && line.ItemCode === packedItem.itemCode);
              if (originalDocLine) {
                  const moninSubClass = getMoninSubClassification(originalDocLine.ItemDescription || originalDocLine.ItemName);
                  const purchaseItemsPerUnit = itemMasterData[packedItem.itemCode]?.PurchaseItemsPerUnit;
                  if (moninSubClass === '750ml') {
                      newCalculatedTotals.totalBotellas750ml += quantity;
                      if (purchaseItemsPerUnit > 0) newCalculatedTotals.totalCajas750ml += (quantity / purchaseItemsPerUnit);
                  } else if (moninSubClass === '1.89L') {
                      newCalculatedTotals.totalBotellas1_89L += quantity;
                      if (purchaseItemsPerUnit > 0) newCalculatedTotals.totalCajas1_89L += (quantity / purchaseItemsPerUnit);
                  } else {
                      newCalculatedTotals.totalBotellas1L += quantity;
                      if (purchaseItemsPerUnit > 0) newCalculatedTotals.totalCajas1L += (quantity / purchaseItemsPerUnit);
                  }
              }
          } 
          else if (type === 'pastilla') {
              const subClass = itemSubClassMap[packedItem.itemCode];
              if (subClass === 'ActiveGreen') newCalculatedTotals.totalCubetasActiveGreen += quantity;
              else if (subClass === 'Preventiva') newCalculatedTotals.totalCubetasPreventivas += quantity;
              else if (subClass === 'Detergente') newCalculatedTotals.totalCubetasDetergentes += quantity;
          } 


          else if (type === 'capsula' && packedItem.lineNum !== null) {
              // 1. Recuperamos la descripción real para saber qué es
              const originalDocLine = deliveryData.DocumentLines.find(line => line.LineNum === packedItem.lineNum && line.ItemCode === packedItem.itemCode);
              const description = originalDocLine ? (originalDocLine.ItemDescription || originalDocLine.ItemName) : packedItem.description;
              
              // 2. Usamos el Helper Maestro
              const bewSubClass = getBewSubClass(description);

              // 3. Clasificamos en la variable GLOBAL (newCalculatedTotals)
              if (bewSubClass === 'capsula') {
                  newCalculatedTotals.totalCapsulas += quantity;
                  const purchaseItemsPerUnit = itemMasterData[packedItem.itemCode]?.PurchaseItemsPerUnit;
                  if (purchaseItemsPerUnit > 0) newCalculatedTotals.totalCajasCapsulas += (quantity / purchaseItemsPerUnit);
              } 
              else if (bewSubClass === 'sifon_alu_1l') newCalculatedTotals.totalSifonesAluminio1L += quantity;
              else if (bewSubClass === 'sifon_alu_500') newCalculatedTotals.totalSifonesAluminio500 += quantity;
              else if (bewSubClass === 'sifon_acero_1l') newCalculatedTotals.totalSifonesAcero1L += quantity;
              else if (bewSubClass === 'sifon_acero_500') newCalculatedTotals.totalSifonesAcero500 += quantity;
              else {
                  // Si no es ni cápsula ni sifón, es accesorio
                  newCalculatedTotals.totalAccesoriosBew += quantity;
              }
          }




          else {
              // Accesorios suman aquí
              newCalculatedTotals.totalInsumosVarios += quantity;
          }
        });
      });
    });

    // Redondeos
    newCalculatedTotals.totalCajas750ml = parseFloat(newCalculatedTotals.totalCajas750ml.toFixed(2));
    newCalculatedTotals.totalCajas1L = parseFloat(newCalculatedTotals.totalCajas1L.toFixed(2));
    newCalculatedTotals.totalCajas1_89L = parseFloat(newCalculatedTotals.totalCajas1_89L.toFixed(2));
    newCalculatedTotals.totalCajasCapsulas = parseFloat(newCalculatedTotals.totalCajasCapsulas.toFixed(2));

    // Actualizar estado solo si cambió
    if (JSON.stringify(pfsTotals) !== JSON.stringify(newCalculatedTotals)) {
        setPfsTotals(newCalculatedTotals);
    }

  }, [deliveryData, pallets, itemMasterData, itemSubClassMap]);

  const createNewLevelObject = (levelNumber) => ({
    levelNumber: `NIVEL ${levelNumber}`,
    items: [],
    isExpanded: true,
  });

  const createNewPalletObject = (type = 'TARIMA', number = 1, classification = null) => ({
    palletNumber: `${type} ${number}`,
    dimensions: '',
    weight: 0,
    levels: [createNewLevelObject(1)],
    isPalletExpanded: true,
    incompleteBoxWarning: null,
    type: type,
    palletClassification: classification, // Aquí se guarda 'monin', 'pastilla', etc.
    palletPfsTotals: {
      totalBotellas750ml: 0, totalCajas750ml: 0,
      totalBotellas1L: 0, totalCajas1L: 0,
      totalBotellas1_89L: 0, totalCajas1_89L: 0,
      totalCubetasPreventivas: 0, totalCubetasDetergentes: 0, totalCubetasActiveGreen: 0,
      totalCapsulas: 0, totalCajasCapsulas: 0,
    }
  });

  const renumberPallets = (currentPallets) => {
    let palletCounter = 0;
    let boxCounter = 0;
    return currentPallets.map(p => {
      const currentType = p.type || 'TARIMA';
      if (currentType === 'TARIMA') {
        palletCounter++;
        return { ...p, palletNumber: `TARIMA ${palletCounter}` };
      } else {
        boxCounter++;
        return { ...p, palletNumber: `CAJA ${boxCounter}` };
      }
    });
  };

  const fetchDeliveryDetails = async (isInitialLoad = false) => {
    setLoading(true);
    if (isInitialLoad) {
      setSaveValidationAlert(null);
    }

    const defaultPfsTotals = {
      classification: null, totalBotellas750ml: 0, totalBotellas1L: 0, totalBotellas1_89L: 0,
      totalCajas750ml: 0, totalCajas1L: 0, totalCajas1_89L: 0,
      totalCubetasPreventivas: 0, totalCubetasDetergentes: 0, totalCubetasActiveGreen: 0,
      totalCapsulas: 0, totalCajasCapsulas: 0,
      totalSifonesAluminio1L : 0, totalSifonesAluminio500 : 0, totalSifonesAcero1L : 0, totalSifonesAcero500 : 0, totalAccesoriosBew : 0,
      totalInsumosVarios : 0
    };

    if (isInitialLoad) {
      setDeliveryData(null);
      setPallets([]);
      setEvidenceImages([]);
      setItemMasterData({});
      setPfsTotals(defaultPfsTotals);
      setItemSubClassMap({});
    }

    try {
      let response;
      if (packingListId) {
        console.log(`Editor PFS: Cargando listado específico por ID: ${packingListId}`);
        response = await deliveryService.getPackingListById(packingListId);
      } else {
        console.log(`Editor PFS: Cargando por DocEntry: ${docEntry}`);
        response = await deliveryService.getDeliveryDetails(docEntry, '?formato=B');
      }

      if (response.data.success) {
        const data = response.data.data;








        console.log("datos del la entegra/listado");
        console.log(data);
        setDeliveryData(data);

        if (isInitialLoad && data && data.DocumentLines && data.DocumentLines.length > 0) {
          const uniqueItemCodes = [...new Set(data.DocumentLines.map(line => line.ItemCode).filter(Boolean))];
          if (uniqueItemCodes.length > 0) {
            try {
              const itemsDetailsResponse = await deliveryService.getItemsDetails(uniqueItemCodes);
              if (itemsDetailsResponse.data.success) {
                
                const itemsData = itemsDetailsResponse.data.data;
                const masterData = {};
                itemsData.forEach(item => { masterData[item.ItemCode] = item; });
                



                setItemMasterData(masterData);
              } else {
                message.error(itemsDetailsResponse.data.message || "Error al cargar detalles de artículos.");
              }
            } catch (itemError) {
              console.error("Error fetching item details for PFS editor:", itemError);
            }
          }
        }

        let finalPalletsToSet = [];
        let finalPfsTotals = { ...defaultPfsTotals };
        let finalEvidenceImages = [];

        if (isInitialLoad) {
          if (data.packingList && data.packingList.formato === 'B') {
            const {
              pallets: savedPallets,
              entregaPfsTotals,
              evidenceImages: savedImages,
              subClassificationPFS
            } = data.packingList;

            if (savedPallets && Array.isArray(savedPallets) && savedPallets.length > 0) {
              finalPalletsToSet = savedPallets.map(p => ({
                ...(p || {}),
                palletNumber: p.palletNumber || `TARIMA ${p._id || Math.random()}`,
                type: p.type || 'TARIMA',
                isPalletExpanded: p.isPalletExpanded === undefined ? true : !!p.isPalletExpanded,
                levels: (p.levels && Array.isArray(p.levels) && p.levels.length > 0
                  ? p.levels.map(l => ({
                    ...(l || {}),
                    levelNumber: l.levelNumber || `NIVEL ${l._id || Math.random()}`,
                    isExpanded: l.isExpanded === undefined ? true : !!l.isExpanded,
                    items: (l.items || []).map(item => ({ ...item, clientSideId: item.clientSideId || uuidv4() }))
                  }))
                  : [createNewLevelObject(1)]),
                incompleteBoxWarning: p.incompleteBoxWarning || null,
                palletPfsTotals: p.palletPfsTotals || { ...defaultPfsTotals }
              }));


            } else {
                // Es un listado NUEVO, no cargado de la BD.
                // Hacemos una pre-detección para decidir el estado inicial.
                let preHasMonin = false;
                let preHasPastilla = false;
                let preHasCapsula = false;
                let preClasificacionSimple = null;

                if (data.DocumentLines && data.DocumentLines.length > 0) {
                    for (const line of data.DocumentLines) {
                        // Usamos el helper que ya creamos
                        const itemType = getItemPFSType(line.ItemCode); 
                        if (itemType === 'monin') preHasMonin = true;
                        else if (itemType === 'pastilla') preHasPastilla = true;
                        else if (itemType === 'capsula') preHasCapsula = true;
                    }
                }
                
                const preTiposEncontrados = (preHasMonin ? 1 : 0) + (preHasPastilla ? 1 : 0) + (preHasCapsula ? 1 : 0);
                const isCombinado = (preTiposEncontrados > 1);

                if (isCombinado) {
                    // 1. Es 'combinado': Empezamos con CERO tarimas.
                    // Esto fuerza al usuario a usar los botones especializados.
                    finalPalletsToSet = [];
                } else if (data.DocumentLines?.length > 0) {
                    // 2. Es 'simple' (o solo 'otros'): Creamos la TARIMA 1.
                    // Asignamos la clasificación simple si la encontramos.
                    if (preHasMonin) preClasificacionSimple = 'monin';
                    else if (preHasPastilla) preClasificacionSimple = 'pastilla';
                    else if (preHasCapsula) preClasificacionSimple = 'capsula';
                    
                    finalPalletsToSet = [createNewPalletObject('TARIMA', 1, preClasificacionSimple)];
                } else {
                    // 3. No tiene líneas de documento, dejar vacío.
                    finalPalletsToSet = [];
                }
            }





            if (entregaPfsTotals) {
              finalPfsTotals = { ...defaultPfsTotals, ...entregaPfsTotals };
            } else if (subClassificationPFS) {
              finalPfsTotals.classification = subClassificationPFS;
            }
            finalEvidenceImages = savedImages && Array.isArray(savedImages) ? savedImages : [];
          } else {
            // Es un listado NUEVO (sin data.packingList)
            // Hacemos la pre-detección para decidir el estado inicial.
            let preHasMonin = false;
            let preHasPastilla = false;
            let preHasCapsula = false;
            let preClasificacionSimple = null;

            if (data.DocumentLines && data.DocumentLines.length > 0) {
                for (const line of data.DocumentLines) {
                    const itemType = getItemPFSType(line.ItemCode); 
                    if (itemType === 'monin') preHasMonin = true;
                    else if (itemType === 'pastilla') preHasPastilla = true;
                    else if (itemType === 'capsula') preHasCapsula = true;
                }
            }
            
            const preTiposEncontrados = (preHasMonin ? 1 : 0) + (preHasPastilla ? 1 : 0) + (preHasCapsula ? 1 : 0);
            const isCombinado = (preTiposEncontrados > 1);

            if (isCombinado) {
                // 1. Es 'combinado': Empezamos con CERO tarimas.
                finalPalletsToSet = [];
            } else if (data.DocumentLines?.length > 0) {
                // 2. Es 'simple' (o solo 'otros'): Creamos la TARIMA 1.
                if (preHasMonin) preClasificacionSimple = 'monin';
                else if (preHasPastilla) preClasificacionSimple = 'pastilla';
                else if (preHasCapsula) preClasificacionSimple = 'capsula';
                
                finalPalletsToSet = [createNewPalletObject('TARIMA', 1, preClasificacionSimple)];
            } else {
                // 3. No tiene líneas de documento, dejar vacío.
                finalPalletsToSet = [];
            }
          }

          setPallets(renumberPallets(finalPalletsToSet));
          setPfsTotals(finalPfsTotals);
          setEvidenceImages(finalEvidenceImages);

        } else {
          if (data.packingList && data.packingList.formato === 'B') {
            if (data.packingList.evidenceImages && Array.isArray(data.packingList.evidenceImages)) {
              setEvidenceImages(data.packingList.evidenceImages);
            }
            setDeliveryData(prev => ({
              ...prev,
              packingList: {
                ...(prev?.packingList || {}),
                ...data.packingList,
                formato: 'B'
              }
            }));
            if (data.packingList.entregaPfsTotals && JSON.stringify(pfsTotals) !== JSON.stringify(data.packingList.entregaPfsTotals)) {
              setPfsTotals(data.packingList.entregaPfsTotals);
            } else if (data.packingList.subClassificationPFS && pfsTotals.classification !== data.packingList.subClassificationPFS) {
              setPfsTotals(prev => ({ ...prev, classification: data.packingList.subClassificationPFS }));
            }
          }
        }

      } else {
        message.error(response.data.message || 'Error loading delivery details for B Editor');
      }
    } catch (error) {
      console.error('B Editor: Error in fetchDeliveryDetails:', error);
      message.error(error.response?.data?.message || 'Error fetching delivery details for B Editor');
      if (isInitialLoad) {
        setDeliveryData(null);
        setPallets([]);
        setEvidenceImages([]);
        setItemMasterData({});
        setPfsTotals(defaultPfsTotals);
        setItemSubClassMap({});
      }
    } finally {
      setLoading(false);
    }
  };

  // +++ INICIO: FUNCIÓN AJUSTADA PARA SER MÁS ROBUSTA CON DATOS MANUALES +++
  const updatePalletDetails = (palletIndex, field, value) => {
    setSaveValidationAlert(null);
    setPallets(p => {
      let palletsToUpdate = p.map((pallet, i) => {
        if (i === palletIndex) {
          if (field === 'dimensions') {
            const definition = activePalletDefinitions.find(def => def.dimensions === value);
            return { ...pallet, dimensions: value, type: definition ? definition.type : pallet.type, incompleteBoxWarning: null };
          }
          if (field === 'weight') {
            return { ...pallet, weight: value, incompleteBoxWarning: null };
          }
          return { ...pallet, [field]: value };
        }
        return pallet;
      });
      return renumberPallets(palletsToUpdate);
    });
  };
  // +++ FIN: FUNCIÓN AJUSTADA +++

const addNewPallet = (classification = null) => {
    setSaveValidationAlert(null);
    setPallets(prevPallets => {
      // Al crear la tarima, le asignamos su clasificación para filtrar qué productos acepta
      const newPallet = createNewPalletObject('TARIMA', 1, classification);
      const updatedPallets = [...prevPallets, newPallet];
      return renumberPallets(updatedPallets);
    });
  };

  const removePallet = (palletIndex) => {
    setSaveValidationAlert(null);
    setPallets(prevPallets => {
      const updatedPallets = prevPallets.filter((_, i) => i !== palletIndex);
      return renumberPallets(updatedPallets);
    });
  };

  const togglePalletExpansion = (palletIndex) => {
    setPallets(prevPallets =>
      prevPallets.map((pallet, pIdx) =>
        pIdx === palletIndex ? { ...pallet, isPalletExpanded: !pallet.isPalletExpanded } : pallet
      )
    );
  };

  const addLevelToPallet = (palletIndex) => {
    setSaveValidationAlert(null);
    setPallets(prevPallets => {
      return prevPallets.map((pallet, pIdx) => {
        if (pIdx === palletIndex) {
          const nextLevelNumber = pallet.levels.length + 1;
          return {
            ...pallet,
            levels: [...pallet.levels, createNewLevelObject(nextLevelNumber)],
            incompleteBoxWarning: null
          };
        }
        return pallet;
      });
    });
  };

  const removeLevelFromPallet = (palletIndex, levelIndex) => {
    setSaveValidationAlert(null);
    setPallets(prevPallets => {
      const newPallets = prevPallets.map((pallet, pIdx) => {
        if (pIdx === palletIndex) {
          const updatedLevels = pallet.levels.filter((_, lIdx) => lIdx !== levelIndex)
            .map((level, newLIdx) => ({
              ...level,
              levelNumber: `NIVEL ${newLIdx + 1}`
            }));
          return { ...pallet, levels: updatedLevels, incompleteBoxWarning: null };
        }
        return pallet;
      });
      return newPallets;
    });
  };

  const toggleLevelExpansion = (palletIndex, levelIndex) => {
    setPallets(prevPallets =>
      prevPallets.map((pallet, pIdx) => {
        if (pIdx === palletIndex) {
          const updatedLevels = pallet.levels.map((level, lIdx) =>
            lIdx === levelIndex ? { ...level, isExpanded: !level.isExpanded } : level
          );
          return { ...pallet, levels: updatedLevels };
        }
        return pallet;
      })
    );
  };

  const addItemToLevel = (palletIndex, levelIndex) => {
    setSaveValidationAlert(null);
    const newItem = {
      clientSideId: uuidv4(),
      lineNum: null,
      itemCode: '',
      quantity: 1,
      description: '',
      weight: 0,
      dimensions: '',
      purchaseItemsPerUnit: 1
    };
    setPallets(prevPallets => {
      return prevPallets.map((pallet, pIdx) => {
        if (pIdx === palletIndex) {
          const updatedLevels = pallet.levels.map((level, lIdx) => {
            if (lIdx === levelIndex) {
              return { ...level, items: [...level.items, newItem] };
            }
            return level;
          });
          return { ...pallet, levels: updatedLevels, incompleteBoxWarning: null };
        }
        return pallet;
      });
    });
  };

  const removeItemFromLevel = (palletIndex, levelIndex, itemIndex) => {
    setSaveValidationAlert(null);
    setPallets(prevPallets => {
      const newPallets = prevPallets.map((pallet, pIdx) => {
        if (pIdx === palletIndex) {
          const updatedLevels = pallet.levels.map((level, lIdx) => {
            if (lIdx === levelIndex) {
              return { ...level, items: level.items.filter((_, itmIdx) => itmIdx !== itemIndex) };
            }
            return level;
          });
          return { ...pallet, levels: updatedLevels, incompleteBoxWarning: null };
        }
        return pallet;
      });
      return newPallets;
    });
  };

  const updateItemInLevel = (palletIndex, levelIndex, itemIndex, field, value) => {
    setSaveValidationAlert(null);
    setPallets(prev => prev.map((p, idx) => idx === palletIndex ? { ...p, incompleteBoxWarning: null } : p));

    const currentPallet = pallets[palletIndex];
    const currentLevel = currentPallet.levels[levelIndex];
    const currentItem = { ...currentLevel.items[itemIndex] };
    let updatedItem = { ...currentItem };

if (field === 'selectedLineNum' && deliveryData?.DocumentLines) {
      const selectedSapLineNum = value;
      const selectedOriginalLine = deliveryData.DocumentLines.find(line => line.LineNum === selectedSapLineNum);

      if (selectedOriginalLine) {
        
        // --- VALIDACIÓN DE MEZCLA ---
        const newItemType = getItemPFSType(selectedOriginalLine.ItemCode);
        const currentLevelItems = pallets[palletIndex].levels[levelIndex].items;

        const existingNeighbor = currentLevelItems.find(item => 
            item.clientSideId !== updatedItem.clientSideId && 
            item.itemCode && 
            getItemPFSType(item.itemCode) !== 'otro' 
        );

        if (existingNeighbor) {
            const neighborType = getItemPFSType(existingNeighbor.itemCode);
            
            // Si hay conflicto...
            if ( (neighborType === 'monin' && newItemType === 'capsula') || 
                 (neighborType === 'capsula' && newItemType === 'monin') ) {
                
                // +++ ACTIVAMOS EL ESTADO DEL MODAL +++
                setMixConflict({ 
                    visible: true, 
                    current: neighborType.toUpperCase(), 
                    intent: newItemType.toUpperCase() 
                });

                return; // <--- DETIENE LA EJECUCIÓN
            }
        }
        
        // SI PASA, PROCEDEMOS...
        // ... (Tu código normal de asignación sigue aquí abajo sin cambios) ...
        updatedItem.itemCode = selectedOriginalLine.ItemCode;
        updatedItem.description = selectedOriginalLine.ItemName || selectedOriginalLine.ItemDescription || '';
        updatedItem.lineNum = selectedOriginalLine.LineNum;
        updatedItem.weight = selectedOriginalLine.Weight || selectedOriginalLine.SalesUnitWeight || 0;
        
        // Dims
        const dims = [];
        if (selectedOriginalLine.Width || selectedOriginalLine.SalesUnitWidth) dims.push(`${selectedOriginalLine.Width || selectedOriginalLine.SalesUnitWidth}`);
        if (selectedOriginalLine.Length || selectedOriginalLine.SalesUnitLength) dims.push(`${selectedOriginalLine.Length || selectedOriginalLine.SalesUnitLength}`);
        if (selectedOriginalLine.Height || selectedOriginalLine.SalesUnitHeight) dims.push(`${selectedOriginalLine.Height || selectedOriginalLine.SalesUnitHeight}`);
        updatedItem.dimensions = dims.length > 0 ? dims.join('X') : '';

        // Factor
        const itemData = itemMasterData[selectedOriginalLine.ItemCode];
        updatedItem.purchaseItemsPerUnit = itemData?.PurchaseItemsPerUnit || 1;

        // Iniciar en Cero
        updatedItem.quantity = 0; 

      } else {
        // Reset
        updatedItem.itemCode = ''; updatedItem.description = ''; updatedItem.lineNum = null;
        updatedItem.weight = 0; updatedItem.dimensions = ''; updatedItem.quantity = 0; updatedItem.purchaseItemsPerUnit = 1;
      }
    }

 else if (field === 'cajas' && (pfsTotals.classification === 'capsula' || pfsTotals.classification === 'monin' || pfsTotals.classification === 'combinado')) {
      let numCajas = parseInt(value, 10) || 0;
      let newQuantity = 0;
      let equivalency = updatedItem.purchaseItemsPerUnit || itemMasterData[currentItem.itemCode]?.PurchaseItemsPerUnit || 1;
     

      if (!equivalency || equivalency === 0) {
        if (currentItem.itemCode) message.warn(`Equivalencia (PurchaseItemsPerUnit) no encontrada o es 0 para ${currentItem.itemCode}. Usando 1.`, 3);
        equivalency = 1;
      }
      
      newQuantity = numCajas * equivalency;
      
      updatedItem.quantity = parseInt(newQuantity, 10);
    } else if (field === 'quantity') {
      let newQuantity = parseInt(value, 10) || 0;
      updatedItem.quantity = newQuantity;
    } else {
      updatedItem = { ...updatedItem, [field]: value };
    }

    if (field === 'selectedLineNum' || field === 'cajas' || field === 'quantity') {
      const currentItemCodeToCheck = updatedItem.itemCode;
      const currentItemLineNumToCheck = updatedItem.lineNum;
      const finalQuantityToCheck = updatedItem.quantity;

      if (currentItemCodeToCheck && currentItemLineNumToCheck !== null && deliveryData?.DocumentLines) {
        const originalDocLine = deliveryData.DocumentLines.find(
          line => line.ItemCode === currentItemCodeToCheck && line.LineNum === currentItemLineNumToCheck
        );
        if (originalDocLine) {
          const originalQuantity = originalDocLine.Quantity || 0;
          let currentTotalPackedForLine = 0;
          pallets.forEach((p, pIdxLoop) => {
            p.levels.forEach((lvl, lIdxLoop) => {
              lvl.items.forEach((item, itmIdxLoop) => {
                if (item.itemCode === currentItemCodeToCheck && item.lineNum === currentItemLineNumToCheck &&
                  !(pIdxLoop === palletIndex && lIdxLoop === levelIndex && itmIdxLoop === itemIndex)) {
                  currentTotalPackedForLine += (parseInt(item.quantity, 10) || 0);
                }
              });
            });
          });
          const potentialTotalPacked = currentTotalPackedForLine + finalQuantityToCheck;
          if (potentialTotalPacked > originalQuantity) {
            message.error(`Cantidad para ${currentItemCodeToCheck} (Línea ${currentItemLineNumToCheck}) excede límite (${originalQuantity}). Máx. a añadir: ${Math.max(0, originalQuantity - currentTotalPackedForLine)}.`);
            updatedItem.quantity = currentItem.quantity;
          }
        }
      }
    }

    setPallets(prevPallets => {
      return prevPallets.map((pallet, pIdx) => {
        if (pIdx === palletIndex) {
          const updatedLevels = pallet.levels.map((level, lIdx) => {
            if (lIdx === levelIndex) {
              const updatedItems = level.items.map((item, itmIdx) => {
                if (itmIdx === itemIndex) {
                  return updatedItem;
                }
                return item;
              });
              return { ...level, items: updatedItems };
            }
            return level;
          });
          return { ...pallet, levels: updatedLevels };
        }
        return pallet;
      });
    });
  };
  // --- Fragmento para la constante 'overallProgress' ---
// --- CÁLCULO DE PROGRESO CORREGIDO ---
  const overallProgress = useMemo(() => {
    if (!deliveryData?.DocumentLines || deliveryData.DocumentLines.length === 0) { return 0; }
    
    let totalOrderQuantity = 0;
    let totalEffectivelyPackedQuantity = 0;

    deliveryData.DocumentLines.forEach(docLine => {
      // Validamos que sea número
      const qty = parseFloat(docLine.Quantity) || 0;
      if (qty > 0) {
        totalOrderQuantity += qty;
        
        let packedForThisDocLine = 0;
        pallets.forEach(pallet => {
          pallet.levels.forEach(level => {
            level.items.forEach(item => {
              // Comparación estricta de IDs
              if (item.lineNum !== null && item.itemCode === docLine.ItemCode && item.lineNum === docLine.LineNum) {
                packedForThisDocLine += (parseFloat(item.quantity) || 0); // Usamos Float por seguridad
              }
            });
          });
        });
        // No podemos empacar más del 100% de una línea para el progreso general
        totalEffectivelyPackedQuantity += Math.min(packedForThisDocLine, qty);
      }
    });

    if (totalOrderQuantity === 0) return 100;

    // Calculamos porcentaje
    const rawPercent = (totalEffectivelyPackedQuantity / totalOrderQuantity) * 100;
    
    // Si es muy poco (0.1%) mostramos al menos 1% si hay algo empacado, para feedback visual
    if (rawPercent > 0 && rawPercent < 1) return 1;
    
    return Math.floor(rawPercent); 
  }, [deliveryData, pallets]);

 
  const savePackingList = async () => {
    setSaveValidationAlert(null);

    // 1. Validaciones Básicas
    if (!deliveryData) {
      setSaveValidationAlert("No hay datos de entrega cargados.");
      return;
    }

    // 2. Validación de Estructura (Niveles Vacíos)
    for (const pallet of pallets) {
      if (!pallet.levels || pallet.levels.length === 0) {
        setSaveValidationAlert(`Error: La '${pallet.palletNumber}' no tiene niveles.`);
        return;
      }
      for (const level of pallet.levels) {
        if (!level.items || level.items.length === 0) {
          setSaveValidationAlert(`Error: El '${level.levelNumber}' en '${pallet.palletNumber}' está vacío.`);
          return;
        }
        for (const item of level.items) {
          if (!item.itemCode) {
            setSaveValidationAlert(`Error: Hay filas sin artículo seleccionado en '${pallet.palletNumber}'.`);
            return;
          }
        }
      }
    }

    // 3. Validación de Cantidades Completas
    let isPackingComplete = true;
    if (deliveryData?.DocumentLines) {
      for (const docLine of deliveryData.DocumentLines) {
        const requiredQty = docLine.Quantity || 0;
        if (requiredQty <= 0) continue;
        let packedQty = 0;
        pallets.forEach(pallet => {
          pallet.levels.forEach(level => {
            level.items.forEach(item => {
              if (item.itemCode === docLine.ItemCode && item.lineNum === docLine.LineNum) {
                packedQty += (parseInt(item.quantity, 10) || 0);
              }
            });
          });
        });
        if (packedQty < requiredQty) {
          isPackingComplete = false;
          break;
        }
      }
    }

    if (!isPackingComplete) {
      setIncompletePercent(overallProgress);
      setShowErrorModal(true);
      return;
    }
//
    // 4. Validación de Evidencias (Mínimo 6)
   if (!evidenceImages || evidenceImages.length < minPhotosRequired) { // <--- USAR VARIABLE
    setSaveValidationAlert(`Favor de completar todos los datos del empaque: Debe agregar al menos ${minPhotosRequired} fotos de evidencia.`);
    return;
}

    // 5. Validación de Datos de Tarima (Peso/Dims)
    let palletDataComplete = true;
    for (const pallet of pallets) {
      if (!pallet.dimensions || String(pallet.dimensions).trim() === '') { palletDataComplete = false; break; }
      if (!(typeof pallet.weight === 'number' && pallet.weight > 0)) { palletDataComplete = false; break; }
    }
    if (!palletDataComplete) {
      setSaveValidationAlert("Verifique dimensiones y peso de todas las tarimas.");
      return;
    }

    // --- PROCESO DE GUARDADO ---
    try {
      setSaving(true);
      
      // Subida de imágenes (Lógica visual)
      const newImagesToUpload = evidenceImages.filter(img => img.imageData && !img.sapAttachmentAbsoluteEntry);
      setTotalImagesToUpload(newImagesToUpload.length);
      if (newImagesToUpload.length > 0) {
        setUploadProgressVisible(true); 
        setCurrentImageIndex(0); 
        setCurrentImageProgress(0); 
        setUploadStatus('Preparando carga de imágenes...');
      }

      // A. Calcular totales individuales por tarima
      const palletsPayload = pallets.map(pallet => ({
        palletNumber: pallet.palletNumber,
        dimensions: pallet.dimensions,
        weight: pallet.weight,
        type: pallet.type || 'TARIMA',
        palletClassification: pallet.palletClassification || null, // Guardamos si es Monin/Pastilla
        
        // Calculamos totales usando la función auxiliar (asegúrate de tener la versión nueva de esta función también)
        palletPfsTotals: calculatePalletPfsTotalsForPayload(pallet, deliveryData, itemMasterData, pfsTotals.classification, itemSubClassMap),
        
        levels: pallet.levels.map(level => ({
          levelNumber: level.levelNumber,
          items: level.items.map(item => ({
            lineNum: item.lineNum,
            itemCode: item.itemCode,
            description: item.description,
            quantity: parseInt(item.quantity, 10) || 0,
            purchaseItemsPerUnit: item.purchaseItemsPerUnit || 1,
            weight: item.weight,
            dimensions: item.dimensions,
            // NOTA: NO enviamos 'cajas', el backend no lo necesita.
          }))
        }))
      }));

      // B. Calcular Totales Globales de la Entrega (Header)
      // Sumamos lo que calculó cada tarima para tener el gran total
      const globalTotals = {
          totalBotellas750ml: palletsPayload.reduce((acc, p) => acc + (p.palletPfsTotals.totalBotellas750ml || 0), 0),
          totalCajas750ml:    palletsPayload.reduce((acc, p) => acc + (p.palletPfsTotals.totalCajas750ml || 0), 0),
          totalBotellas1L:    palletsPayload.reduce((acc, p) => acc + (p.palletPfsTotals.totalBotellas1L || 0), 0),
          totalCajas1L:       palletsPayload.reduce((acc, p) => acc + (p.palletPfsTotals.totalCajas1L || 0), 0),
          totalBotellas1_89L: palletsPayload.reduce((acc, p) => acc + (p.palletPfsTotals.totalBotellas1_89L || 0), 0),
          totalCajas1_89L:    palletsPayload.reduce((acc, p) => acc + (p.palletPfsTotals.totalCajas1_89L || 0), 0),
          
          totalCubetasPreventivas: palletsPayload.reduce((acc, p) => acc + (p.palletPfsTotals.totalCubetasPreventivas || 0), 0),
          totalCubetasDetergentes: palletsPayload.reduce((acc, p) => acc + (p.palletPfsTotals.totalCubetasDetergentes || 0), 0),
          totalCubetasActiveGreen: palletsPayload.reduce((acc, p) => acc + (p.palletPfsTotals.totalCubetasActiveGreen || 0), 0),
          
          totalCapsulas:      palletsPayload.reduce((acc, p) => acc + (p.palletPfsTotals.totalCapsulas || 0), 0),
          totalCajasCapsulas: palletsPayload.reduce((acc, p) => acc + (p.palletPfsTotals.totalCajasCapsulas || 0), 0),

            // --- AGREGAR ESTOS CAMPOS PARA QUE SE GUARDEN EN BD ---
          totalSifonesAluminio1L: palletsPayload.reduce((acc, p) => acc + (p.palletPfsTotals.totalSifonesAluminio1L || 0), 0),
          totalSifonesAluminio500: palletsPayload.reduce((acc, p) => acc + (p.palletPfsTotals.totalSifonesAluminio500 || 0), 0),
          totalSifonesAcero1L: palletsPayload.reduce((acc, p) => acc + (p.palletPfsTotals.totalSifonesAcero1L || 0), 0),
          totalSifonesAcero500: palletsPayload.reduce((acc, p) => acc + (p.palletPfsTotals.totalSifonesAcero500 || 0), 0),
          totalAccesoriosBew: palletsPayload.reduce((acc, p) => acc + (p.palletPfsTotals.totalAccesoriosBew || 0), 0),

          // +++ NUEVO: SUMA GLOBAL DE ACCESORIOS PARA PDF +++
          totalInsumosVarios: palletsPayload.reduce((acc, p) => acc + (p.palletPfsTotals.totalInsumosVarios || 0), 0)
      };

      const payload = {
        docEntry: deliveryData.DocEntry,
        formato: 'B',
        status: 'completed',
        docNumSAP: deliveryData.DocNum,
        cardCode: deliveryData.CardCode,
        cardName: deliveryData.CardName,
        ordenDeCompra: deliveryData.NumAtCard || '',
        packDate: moment().format('YYYY-MM-DD'),
        packUser: user?.fullName || 'Usuario del Sistema',
        comments: form.getFieldValue('comments') || '',
        
        subClassificationPFS: pfsTotals.classification,
        entregaPfsTotals: globalTotals, // Enviamos los totales calculados
        
        pallets: palletsPayload,
        evidenceImages: evidenceImages,
        isEditMode: !!(deliveryData?.packingList?.packingListNumber && deliveryData?.packingList?.formato === 'B'),
      };
console.log('json de listado a guardar');
console.log(payload);
      // Enviar
      const response = await deliveryService.savePfsPackingList(docEntry, payload);

      if (response.data.success) {
        const backendPackingList = response.data.data;
        setSavedFolio(backendPackingList.packingListNumber);
        
        // Actualizar estado local
        setDeliveryData(prev => ({
          ...prev,
          packingList: { ...backendPackingList, formato: 'B' }
        }));
        // (Aquí iría la lógica de recarga de datos si fuera necesaria, pero el modal de éxito bloquea la vista)
        setShowSuccessModal(true);
      } else {
        setSaveValidationAlert(response.data.message || 'Error al guardar.');
      }
    } catch (error) {
      console.error('Error Save:', error);
      setSaveValidationAlert(error.response?.data?.message || 'Error de servidor.');
    } finally {
      setSaving(false); 
      setUploadProgressVisible(false);
    }
  };
  
  const generatePDF = async () => {
    setSaveValidationAlert(null);
    setPdfErrorAlert(null); // Limpiar errores anteriores
    const packingListId = deliveryData?.packingList?._id;

    if (!packingListId || deliveryData.packingList.formato !== 'B') {
      message.warning('Debe guardar el listado de empaque B primero para generar el PDF.');
      return;
    }
    message.info("Generando PDF para Listado B...");
    setPrintLoading(true);
    try {
      await deliveryService.generatePDF(packingListId);
    } catch (error) {
      console.error("Error al generar PDF B:", error);
      message.error(error.response?.data?.message || "Error al generar PDF B.");
      setPdfErrorAlert("No se pudo generar el PDF. Por favor, intente de nuevo más tarde.");
    } finally {
      setPrintLoading(false);
    }
  };

  const generateReportByPalletPDF = async () => {
    setSaveValidationAlert(null);
    setPdfErrorAlert(null); // Limpiar errores anteriores
    const packingListId = deliveryData?.packingList?._id;

    if (!packingListId || deliveryData.packingList.formato !== 'B') {
      message.warning('Debe guardar el listado de empaque B primero para generar el reporte por tarima.');
      return;
    }
    message.info("Generando Reporte por Tarima...");
    setReportByPalletLoading(true);
    try {
      await deliveryService.generatePfsReportByPalletPDF(packingListId);
    } catch (error) {
      console.error("Error al generar el reporte por tarima:", error);
      message.error(error.response?.data?.message || "Error al generar el reporte por tarima.");
      setPdfErrorAlert("No se pudo generar el PDF por tarimas. Por favor, intente de nuevo más tarde.");
    } finally {
      setReportByPalletLoading(false);
    }
  };

  const handlePhotoCaptureComplete = () => {
    setSaveValidationAlert(null);
    setPhotoQrVisible(false);
    message.info('B Editor: Captura finalizada. Actualizando datos...');
    fetchDeliveryDetails(false);
  };

  const totalUploadProgress = useMemo(() => { if (totalImagesToUpload === 0) return 0; const completedImages = currentImageIndex; const currentProgress = currentImageProgress / 100; return Math.round(((completedImages + currentProgress) / totalImagesToUpload) * 100); }, [currentImageIndex, currentImageProgress, totalImagesToUpload]);
  useEffect(() => { let intervalId = null; if (uploadProgressVisible && currentImageIndex < totalImagesToUpload) { setUploadStatus(`Subiendo imagen ${currentImageIndex + 1} de ${totalImagesToUpload} a SAP...`); intervalId = setInterval(() => { setCurrentImageProgress(prev => { const newProgress = prev + 5; if (newProgress >= 100) { clearInterval(intervalId); setTimeout(() => { if (currentImageIndex < totalImagesToUpload - 1) { setCurrentImageIndex(prevIdx => prevIdx + 1); setCurrentImageProgress(0); } else { setUploadStatus('¡Imágenes subidas exitosamente!'); } }, 500); return 100; } return newProgress; }); }, 200); } return () => { if (intervalId) clearInterval(intervalId); }; }, [uploadProgressVisible, currentImageIndex, totalImagesToUpload]);

  const handleBack = () => {
    if (onBackFromProp) {
      onBackFromProp();
    } else {
      navigate(location.state?.from || '/deliveries');
    }
  };


const renderPfsTotals = () => {
    // 1. Detección de Categorías Activas
    const hasMonin = pfsTotals.totalBotellas750ml > 0 || pfsTotals.totalBotellas1L > 0 || pfsTotals.totalBotellas1_89L > 0;
    const hasSifones = pfsTotals.totalSifonesAluminio1L > 0 || pfsTotals.totalSifonesAluminio500 > 0 || pfsTotals.totalSifonesAcero1L > 0 || pfsTotals.totalSifonesAcero500 > 0;
    const hasPastillas = pfsTotals.totalCubetasPreventivas > 0 || pfsTotals.totalCubetasDetergentes > 0 || pfsTotals.totalCubetasActiveGreen > 0;
    const hasCapsulas = pfsTotals.totalCapsulas > 0 || pfsTotals.totalCajasCapsulas > 0;
    
    const hasAccesoriosBew = pfsTotals.totalAccesoriosBew > 0;
    const hasInsumosVarios = pfsTotals.totalInsumosVarios > 0;
    const hasVarios = hasAccesoriosBew || hasInsumosVarios;

    // 2. Cálculo del "Score"
    const activeBlocksCount = [hasMonin, hasSifones, hasPastillas, hasCapsulas, hasVarios].filter(Boolean).length;

    if (activeBlocksCount === 0) {
      return <Text type="secondary" style={{paddingTop: '10px', display: 'block'}}>Sin totales clasificados.</Text>;
    }

    // 3. Regla de Decisión: ¿Complejo (>=3) o Simple?
    const isComplexMode = activeBlocksCount >= 3;

    // --- CONTENIDOS (Funciones de renderizado puro) ---
    const renderMoninContent = () => (
      <Table
        dataSource={[
          { key: '1', sizeLabel: '750 ML', totalBotellasPorTamano: pfsTotals.totalBotellas750ml, totalCajasPorTamano: pfsTotals.totalCajas750ml.toFixed(2) },
          { key: '2', sizeLabel: '1 L',    totalBotellasPorTamano: pfsTotals.totalBotellas1L,    totalCajasPorTamano: pfsTotals.totalCajas1L.toFixed(2) },
          { key: '3', sizeLabel: '1.89 L', totalBotellasPorTamano: pfsTotals.totalBotellas1_89L, totalCajasPorTamano: pfsTotals.totalCajas1_89L.toFixed(2) },
        ].filter(r => r.totalBotellasPorTamano > 0)}
        columns={[
          { title: 'Contenido', dataIndex: 'sizeLabel', key: 'sizeLabel' },
          { title: 'Total Botellas', dataIndex: 'totalBotellasPorTamano', key: 'totalBotellasPorTamano', align: 'right' },
          { title: 'Total Cajas', dataIndex: 'totalCajasPorTamano', key: 'totalCajasPorTamano', align: 'right' },
        ]}
        pagination={false} size="small" bordered
      />
    );

    const renderSifonesContent = () => (
      <Table
        dataSource={[
          { key: 's1', material: 'Aluminio', t1l: pfsTotals.totalSifonesAluminio1L, t500: pfsTotals.totalSifonesAluminio500 },
          { key: 's2', material: 'Acero / Inox', t1l: pfsTotals.totalSifonesAcero1L, t500: pfsTotals.totalSifonesAcero500 },
        ].filter(r => r.t1l > 0 || r.t500 > 0)}
        columns={[
          { title: '', dataIndex: 'material', key: 'material' },
          { title: '1 Litro', dataIndex: 't1l', key: 't1l', align: 'right' },
          { title: '500 ML', dataIndex: 't500', key: 't500', align: 'right' },
        ]}
        pagination={false} size="small" bordered
      />
    );

    const renderPastillasContent = () => (
      <Descriptions bordered size="small" column={1}>
        <Descriptions.Item label="Total Cubetas Preventivas">{pfsTotals.totalCubetasPreventivas}</Descriptions.Item>
        <Descriptions.Item label="Total Cubetas Detergentes">{pfsTotals.totalCubetasDetergentes}</Descriptions.Item>
        <Descriptions.Item label="Total Cubetas ActiveGreen">{pfsTotals.totalCubetasActiveGreen}</Descriptions.Item>
      </Descriptions>
    );

    const renderCapsulasContent = () => (
      <Descriptions bordered size="small" column={1}>
        <Descriptions.Item label="Total Cápsulas">{pfsTotals.totalCapsulas}</Descriptions.Item>
        <Descriptions.Item label="Total Cajas">{pfsTotals.totalCajasCapsulas.toFixed(2)}</Descriptions.Item>
      </Descriptions>
    );

    const renderVariosContent = () => (
      <Descriptions bordered size="small" column={1}>
        {hasAccesoriosBew && <Descriptions.Item label="Accesorios BEW">{pfsTotals.totalAccesoriosBew} </Descriptions.Item>}
        {hasInsumosVarios && <Descriptions.Item label="Otros Artículos">{pfsTotals.totalInsumosVarios} </Descriptions.Item>}
      </Descriptions>
    );

    // --- RENDER FINAL ---
// ESCENARIO A: MODO COMPLEJO (ACORDEÓN)
    if (isComplexMode) {
        let defaultKey = '1';
        if (!hasMonin) {
            if (hasSifones) defaultKey = '2';
            else if (hasPastillas) defaultKey = '3';
            else if (hasCapsulas) defaultKey = '4';
            else defaultKey = '5';
        }

        // Estilo compartido para que sea IDÉNTICO al modo simple
        // margin: 0 es importante para que no descuadre la barra del acordeón
        const headerStyle = { margin: 0, fontSize: '16px' };

        return (
            <Collapse ghost size="small" style={{ marginTop: 10 }} defaultActiveKey={[defaultKey]}>
                
                {hasMonin && (
                    <Panel header={
                        <Space>
                            <ProfileOutlined />
                            <Title level={5} style={headerStyle}>Totales Monin</Title>
                        </Space>
                    } key="1">
                        {renderMoninContent()}
                    </Panel>
                )}

                {hasCapsulas && (
                    <Panel header={
                        <Space>
                            <ProfileOutlined />
                            <Title level={5} style={headerStyle}>Totales Cápsulas</Title>
                        </Space>
                    } key="2">
                        {renderCapsulasContent()}
                    </Panel>
                )}

                {hasPastillas && (
                    <Panel header={
                        <Space>
                            <ProfileOutlined />
                            <Title level={5} style={headerStyle}>Totales Pastillas</Title>
                        </Space>
                    } key="3">
                        {renderPastillasContent()}
                    </Panel>
                )}

                {hasSifones && (
                    <Panel header={
                        <Space>
                            <ProfileOutlined />
                            <Title level={5} style={headerStyle}>Totales Sifones</Title>
                        </Space>
                    } key="4">
                        {renderSifonesContent()}
                    </Panel>
                )}                        

                {hasVarios && (
                    <Panel header={
                        <Space>
                            <ProfileOutlined />
                           
                            <Title level={5} style={headerStyle}>Totales Otros Artículos</Title>
                        </Space>
                    } key="5">
                        {renderVariosContent()}
                    </Panel>
                )}

            </Collapse>
        );
    }

    // ESCENARIO B: MODO SIMPLE (BLOQUES ABIERTOS)
    return (
        <div style={{ marginTop: 5 }}>
            {hasMonin && (
                <div style={{ marginTop: '15px' }}>
                    <Title level={5} style={{ fontSize: '16px', marginBottom: '8px' }}><Space><ProfileOutlined />Totales Monin</Space></Title>
                    {renderMoninContent()}
                </div>
            )}
            {hasSifones && (
                <div style={{ marginTop: '15px' }}>
                    <Title level={5} style={{ fontSize: '16px', marginBottom: '8px' }}><Space><ProfileOutlined />Totales Sifones</Space></Title>
                    {renderSifonesContent()}
                </div>
            )}
            {hasPastillas && (
                <div style={{ marginTop: '15px' }}>
                    <Title level={5} style={{ fontSize: '16px', marginBottom: '8px' }}><Space><ProfileOutlined />Totales Pastillas</Space></Title>
                    {renderPastillasContent()}
                </div>
            )}
            {hasCapsulas && (
                <div style={{ marginTop: '15px' }}>
                    <Title level={5} style={{ fontSize: '16px', marginBottom: '8px' }}><Space><ProfileOutlined />Totales Cápsulas</Space></Title>
                    {renderCapsulasContent()}
                </div>
            )}
            {hasVarios && (
                <div style={{ marginTop: '15px' }}>
                    <Title level={5} style={{ fontSize: '16px', marginBottom: '8px' }}><Space><ProfileOutlined />Totales Otros Artículos</Space></Title>
                    {renderVariosContent()}
                </div>
            )}
        </div>
    );
  };

const renderPalletSpecificTotals = (pallet) => {
    // 1. Validaciones
    if (!pallet || !pfsTotals.classification || !deliveryData || !itemMasterData) {
      return null;
    }

    // 2. Objeto de totales extendido
    const palletTotalsData = {
      totalBotellas750ml: 0, totalCajas750ml: 0, totalBotellas1L: 0, totalCajas1L: 0,
      totalBotellas1_89L: 0, totalCajas1_89L: 0,
      totalCubetasPreventivas: 0, totalCubetasDetergentes: 0, totalCubetasActiveGreen: 0,
      totalCapsulas: 0, totalCajasCapsulas: 0,
      totalSifonesAluminio1L: 0, totalSifonesAluminio500: 0,
      totalSifonesAcero1L: 0, totalSifonesAcero500: 0,
      totalAccesoriosBew: 0,
      totalInsumosVarios: 0 // <--- Aseguramos que este existe
    };

    // 3. CÁLCULO DE TOTALES
    pallet.levels.forEach(level => {
      level.items.forEach(packedItem => {
        const type = getItemPFSType(packedItem.itemCode);
        if (!type) return;
        const quantity = parseInt(packedItem.quantity, 10) || 0;

        // --- MONIN ---
        if (type === 'monin' && packedItem.lineNum !== null) {
          const originalDocLine = deliveryData.DocumentLines.find(line => line.LineNum === packedItem.lineNum && line.ItemCode === packedItem.itemCode);
          if (originalDocLine) {
            const moninSubClass = getMoninSubClassification(originalDocLine.ItemDescription || originalDocLine.ItemName);
            const purchaseItemsPerUnit = itemMasterData[packedItem.itemCode]?.PurchaseItemsPerUnit;
            if (moninSubClass === '750ml') {
              palletTotalsData.totalBotellas750ml += quantity;
              if (purchaseItemsPerUnit > 0) palletTotalsData.totalCajas750ml += (quantity / purchaseItemsPerUnit);
            } else if (moninSubClass === '1.89L') {
              palletTotalsData.totalBotellas1_89L += quantity;
              if (purchaseItemsPerUnit > 0) palletTotalsData.totalCajas1_89L += (quantity / purchaseItemsPerUnit);
            } else {
              palletTotalsData.totalBotellas1L += quantity;
              if (purchaseItemsPerUnit > 0) palletTotalsData.totalCajas1L += (quantity / purchaseItemsPerUnit);
            }
          }
        }
        // --- PASTILLA ---
        else if (type === 'pastilla') {
          const subClass = itemSubClassMap[packedItem.itemCode];
          if (subClass === 'ActiveGreen') palletTotalsData.totalCubetasActiveGreen += quantity;
          else if (subClass === 'Preventiva') palletTotalsData.totalCubetasPreventivas += quantity;
          else if (subClass === 'Detergente') palletTotalsData.totalCubetasDetergentes += quantity;
        }
        // --- CAPSULA (BEW) Y SIFONES ---
        else if (type === 'capsula' && packedItem.lineNum !== null) {
            const originalDocLine = deliveryData.DocumentLines.find(line => line.LineNum === packedItem.lineNum && line.ItemCode === packedItem.itemCode);
            const description = originalDocLine ? (originalDocLine.ItemDescription || originalDocLine.ItemName) : packedItem.description;
            const bewSubClass = getBewSubClass(description);

            if (bewSubClass === 'capsula') {
                palletTotalsData.totalCapsulas += quantity;
                const purchaseItemsPerUnit = itemMasterData[packedItem.itemCode]?.PurchaseItemsPerUnit;
                if (purchaseItemsPerUnit > 0) palletTotalsData.totalCajasCapsulas += (quantity / purchaseItemsPerUnit);
            }
            else if (bewSubClass === 'sifon_alu_1l') palletTotalsData.totalSifonesAluminio1L += quantity;
            else if (bewSubClass === 'sifon_alu_500') palletTotalsData.totalSifonesAluminio500 += quantity;
            else if (bewSubClass === 'sifon_acero_1l') palletTotalsData.totalSifonesAcero1L += quantity;
            else if (bewSubClass === 'sifon_acero_500') palletTotalsData.totalSifonesAcero500 += quantity;
            else {
                // Es un item BEW pero no es ni capsula ni sifon (ej. refacción)
                palletTotalsData.totalAccesoriosBew += quantity;
            }
        }
        // --- OTROS (EL FIX QUE FALTABA) ---
        else {
            // Si no entró en ninguno de los IF anteriores, es "Otro" (General)
            palletTotalsData.totalInsumosVarios += quantity;
        }
      });
    });
    
    // Redondeos visuales
    palletTotalsData.totalCajas750ml = parseFloat(palletTotalsData.totalCajas750ml.toFixed(2));
    palletTotalsData.totalCajas1L = parseFloat(palletTotalsData.totalCajas1L.toFixed(2));
    palletTotalsData.totalCajas1_89L = parseFloat(palletTotalsData.totalCajas1_89L.toFixed(2));
    palletTotalsData.totalCajasCapsulas = parseFloat(palletTotalsData.totalCajasCapsulas.toFixed(2));

    // 4. RENDERIZADO
    const hasMonin = palletTotalsData.totalBotellas750ml > 0 || palletTotalsData.totalBotellas1L > 0 || palletTotalsData.totalBotellas1_89L > 0;
    const hasPastilla = palletTotalsData.totalCubetasPreventivas > 0 || palletTotalsData.totalCubetasDetergentes > 0 || palletTotalsData.totalCubetasActiveGreen > 0;
    const hasCapsula = palletTotalsData.totalCapsulas > 0 || palletTotalsData.totalCajasCapsulas > 0;
    const hasSifones = palletTotalsData.totalSifonesAluminio1L > 0 || palletTotalsData.totalSifonesAluminio500 > 0 || palletTotalsData.totalSifonesAcero1L > 0 || palletTotalsData.totalSifonesAcero500 > 0;
    const hasAccesorios = palletTotalsData.totalAccesoriosBew > 0;
    const hasOtros = palletTotalsData.totalInsumosVarios > 0; // Flag para otros

    if (!hasMonin && !hasPastilla && !hasCapsula && !hasSifones && !hasAccesorios && !hasOtros) return null;

    return (
      <>
        {/* Monin */}
        {hasMonin && (
          <div style={{ marginTop: '10px', marginBottom: '10px' }}>
            <Title level={5} style={{ marginBottom: '8px', fontSize: '14px' }}>{`Totales Monin (${pallet.palletNumber})`}</Title>
            <Table
              dataSource={[
                { key: 'p1', sizeLabel: '750 ML', totalBotellas: palletTotalsData.totalBotellas750ml, totalCajas: palletTotalsData.totalCajas750ml.toFixed(2) },
                { key: 'p2', sizeLabel: '1 L', totalBotellas: palletTotalsData.totalBotellas1L, totalCajas: palletTotalsData.totalCajas1L.toFixed(2) },
                { key: 'p3', sizeLabel: '1.89 L', totalBotellas: palletTotalsData.totalBotellas1_89L, totalCajas: palletTotalsData.totalCajas1_89L.toFixed(2) },
              ].filter(i => i.totalBotellas > 0)}
              columns={[
                { title: <span style={{ color: '#1890ff' }}>Contenido</span>, dataIndex: 'sizeLabel', key: 'sizeLabel' },
                { title: <span style={{ color: '#1890ff' }}>Total botellas</span>, dataIndex: 'totalBotellas', key: 'totalBotellas', align: 'right' },
                { title: <span style={{ color: '#1890ff' }}>Total cajas</span>, dataIndex: 'totalCajas', key: 'totalCajas', align: 'right' },
              ]}
              pagination={false} size="small" bordered
            />
          </div>
        )}

        {/* Pastillas */}
        {hasPastilla && (
          <div style={{ marginTop: '10px', marginBottom: '5px', padding: '8px', border: '1px solid #f0f0f0', borderRadius: '4px', backgroundColor: '#fff' }}>
            <Row justify="space-between" align="middle">
              <Col> <Text strong>{`Totales Pastillas (${pallet.palletNumber}):`}</Text> </Col>
              <Col>
                <Space size="large">
                  <span><Text style={{ color: '#1890ff', fontWeight: '500' }}>Preventivas: </Text><Text>{palletTotalsData.totalCubetasPreventivas}</Text></span>
                  <span><Text style={{ color: '#1890ff', fontWeight: '500' }}>Detergentes: </Text><Text>{palletTotalsData.totalCubetasDetergentes}</Text></span>
                  <span><Text style={{ color: '#1890ff', fontWeight: '500' }}>ActiveGreen: </Text><Text>{palletTotalsData.totalCubetasActiveGreen}</Text></span>
                </Space>
              </Col>
            </Row>
          </div>
        )}

        {/* Cápsulas */}
        {hasCapsula && (
          <div style={{ marginTop: '10px', marginBottom: '5px', padding: '8px', border: '1px solid #f0f0f0', borderRadius: '4px', backgroundColor: '#fff' }}>
            <Row justify="space-between" align="middle">
              <Col> <Text strong>{`Totales Cápsulas (${pallet.palletNumber}):`}</Text> </Col>
              <Col>
                <Space size="large">
                  <span><Text style={{ color: '#1890ff', fontWeight: '500' }}>Total cápsulas: </Text><Text>{palletTotalsData.totalCapsulas}</Text></span>
                  <span><Text style={{ color: '#1890ff', fontWeight: '500' }}>Total cajas: </Text><Text>{palletTotalsData.totalCajasCapsulas}</Text></span>
                </Space>
              </Col>
            </Row>
          </div>
        )}

        {/* Sifones */}
        {hasSifones && (
          <div style={{ marginTop: '10px' }}>
             <Title level={5} style={{ marginBottom: '8px', fontSize: '14px' }}>{`Totales Sifones (${pallet.palletNumber})`}</Title>
             <Table
              dataSource={[
                { key: 's1', mat: 'Aluminio', t1: palletTotalsData.totalSifonesAluminio1L, t5: palletTotalsData.totalSifonesAluminio500 },
                { key: 's2', mat: 'Acero/Inox', t1: palletTotalsData.totalSifonesAcero1L, t5: palletTotalsData.totalSifonesAcero500 },
              ].filter(row => row.t1 > 0 || row.t5 > 0)}
              columns={[
                { title: <span style={{ color: '#1890ff' }}>Sifones</span>, dataIndex: 'mat', key: 'mat' },
                { title: <span style={{ color: '#1890ff' }}>1 Litro</span>, dataIndex: 't1', key: 't1', align: 'right' },
                { title: <span style={{ color: '#1890ff' }}>500 ML</span>, dataIndex: 't5', key: 't5', align: 'right' },
              ]}
              pagination={false} size="small" bordered
            />
          </div>
        )}

        {/* Accesorios BEW (Simplificado: Título Izq, Dato Der) */}
        {hasAccesorios && (
          <div style={{ marginTop: '10px', marginBottom: '5px', padding: '8px', border: '1px solid #f0f0f0', borderRadius: '4px', backgroundColor: '#fff' }}>
            <Row justify="space-between" align="middle">
              <Col>
                <Text strong>{`Accesorios BEW (${pallet.palletNumber}):`}</Text>
              </Col>
              <Col>
                <span>
                  <Text style={{ color: '#1890ff', fontWeight: '500' }}>Otros Accesorios / Artículos: </Text>
                  <Text>{palletTotalsData.totalAccesoriosBew}</Text>
                </span>
              </Col>
            </Row>
          </div>
        )}

        {/* Insumos Varios / OTROS (Simplificado: Título Izq, Dato Der) */}
        {hasOtros && (
          <div style={{ marginTop: '10px', marginBottom: '5px', padding: '8px', border: '1px solid #f0f0f0', borderRadius: '4px', backgroundColor: '#fff' }}>
            <Row justify="space-between" align="middle">
              <Col>
                <Text strong>{`Otros Artículos / Varios (${pallet.palletNumber}):`}</Text>
              </Col>
              <Col>
                <span>
                  <Text style={{ color: '#1890ff', fontWeight: '500' }}>Total Otros Artículos: </Text>
                  <Text>{palletTotalsData.totalInsumosVarios}</Text>
                </span>
              </Col>
            </Row>
          </div>
        )}
      </>
    );
  };

  const clearPalletIncompleteBoxWarning = (palletIdx) => {
    setPallets(prevPallets =>
      prevPallets.map((p, index) =>
        index === palletIdx ? { ...p, incompleteBoxWarning: null } : p
      )
    );
  };

const handleQuantityBlur = (record, palletIdx, levelIdx, itemIdx) => {
    // Limpiamos la advertencia (esto no cambia)
    setPallets(prevPallets =>
        prevPallets.map((p, index) =>
            index === palletIdx ? { ...p, incompleteBoxWarning: null } : p
        )
    );

    // 1. Obtenemos el tipo del ARTÍCULO de la fila actual
    const itemType = getItemPFSType(record.itemCode);

    // 2. Solo ejecutamos esta lógica si el ARTÍCULO es 'monin' o 'capsula'
    if (itemType === 'monin' || itemType === 'capsula') {
        const itemData = itemMasterData[record.itemCode];
        const purchaseItemsPerUnit = itemData?.PurchaseItemsPerUnit;
        const quantity = record.quantity || 0;

        if (purchaseItemsPerUnit && purchaseItemsPerUnit > 0) {
            const calculatedBoxes = quantity / purchaseItemsPerUnit;
            if (calculatedBoxes % 1 !== 0) {
                // La cantidad no es un múltiplo exacto (caja incompleta)
                const warningMessage = `Para el artículo ${record.itemCode}: Verificar cantidad, caja incompleta.`;
                setPallets(prevPallets =>
                    prevPallets.map((p, index) =>
                        index === palletIdx ? { ...p, incompleteBoxWarning: warningMessage } : p
                    )
                );
            }
        } else if (record.itemCode) {
            // Este 'else if' es para el caso en que el artículo SÍ es monin/capsula
            // pero no encontramos su equivalencia (PurchaseItemsPerUnit)
            console.warn(`No se pudo validar cajas completas para ${record.itemCode} debido a falta de PurchaseItemsPerUnit válido.`);
        }
    }
    // Si el itemType es 'pastilla' o 'otro', simplemente no hace nada,
    // lo cual es correcto.
  };
const getItemTableColumns = (palletIdx, levelIdx) => {
    const palletType = pallets[palletIdx]?.palletClassification || null;

    let baseColumns = [
      {
        title: 'Código',
        dataIndex: 'lineNum',
        key: 'itemSelection',
        width: 150,
        render: (lineNumValue, record, itemIdx) => {
          // --- FILTRO DE PRODUCTOS ---
          const lineasFiltradas = deliveryData?.DocumentLines?.filter(line => {
             const originalQty = line.Quantity || 0;
             if (originalQty <= 0) return false;
             
             let packedQty = 0;
             pallets.forEach(p => p.levels.forEach(lvl => lvl.items.forEach(i => {
                if (i.lineNum === line.LineNum) packedQty += (i.quantity || 0);
             })));
             
             if (packedQty >= originalQty && line.LineNum !== record.lineNum) return false;

             const itemType = getItemPFSType(line.ItemCode);
             if (palletType === 'pastilla' && itemType !== 'pastilla') return false;
             else if ((palletType === 'monin' || palletType === 'capsula') && itemType === 'pastilla') return false;
             
             return true;
          });

          return (
            <Select
              size="small" showSearch value={lineNumValue} placeholder="Seleccionar" style={{ width: '100%' }}
              onChange={(val) => updateItemInLevel(palletIdx, levelIdx, itemIdx, 'selectedLineNum', val)}
              disabled={!canEditContent}
              filterOption={(input, option) => (option?.children?.toString() ?? '').toLowerCase().includes(input.toLowerCase())}
            >
              {lineasFiltradas?.map(line => (
                <Select.Option key={line.LineNum} value={line.LineNum}>{line.ItemCode}</Select.Option>
              ))}
            </Select>
          );
        },
      },
      // --- DESCRIPCIÓN CON TOOLTIP ---
      {
        title: 'Descripción',
        dataIndex: 'description',
        key: 'description',
        render: (text, record) => {
           let pedidoQuantity = 'N/A';
           if (deliveryData?.DocumentLines && record.lineNum !== null) {
             const line = deliveryData.DocumentLines.find(l => l.LineNum === record.lineNum && l.ItemCode === record.itemCode);
             if (line) pedidoQuantity = line.Quantity;
           }
           
           return (
             <Tooltip title={`Cantidad Pedido: ${pedidoQuantity}`}>
               <Input 
                 size="small" 
                 value={text} 
                 readOnly 
                 disabled style={{ border: 'none', background: 'transparent', cursor: 'default' }} />
              </Tooltip>
           );
        }
      },
    ];

 // --- COLUMNA CAJAS (VISUAL: INPUT O CAJA GRIS) ---
    const cajasColumnDefinition = {
        title: 'Cajas', 
        key: 'cajas', 
        width: 90, 
        align: 'center',
        render: (text, record, itemIdx) => {
          const itemType = getItemPFSType(record.itemCode);
          const factor = record.purchaseItemsPerUnit || 1;
          
          // Regla: Es Unitario si NO es Monin/Capsula O si su factor es <= 1
          const isUnitary = (itemType !== 'monin' && itemType !== 'capsula') || factor <= 1;
          const disabled = !canEditContent || record.lineNum === null;

          
      if (isUnitary) {
              return (
                <div style={{ textAlign: 'center', width: '100%' }}>
                    
                       <Tag>N/A</Tag>
                    
                </div>
              );
          }

          // CÁLCULO VISUAL (Solo para los que sí usan cajas - Monin/Cápsulas):
          let displayValue = 0;
          if (record.quantity) {
             displayValue = Math.floor(record.quantity / factor); 
          }

          return (
            <InputNumber
              size="small" 
              min={0}
              value={displayValue}
              precision={0}  
              step={1}
              style={{ width: '100%' }}
              disabled={disabled} 
              onChange={(numCajas) => {
                  updateItemInLevel(palletIdx, levelIdx, itemIdx, 'cajas', numCajas); 
              }}
            />
          );
        },
    };


    baseColumns.push(cajasColumnDefinition);

    // --- COLUMNA CANTIDAD ---
    baseColumns.push({
      title: 'Cant', dataIndex: 'quantity', key: 'quantity', width: 80,
      render: (text, record, itemIdx) => (
        <InputNumber
          size="small" min={0} precision={0} value={text}
          onChange={(val) => updateItemInLevel(palletIdx, levelIdx, itemIdx, 'quantity', val)}
          onBlur={() => handleQuantityBlur(record, palletIdx, levelIdx, itemIdx)}
          style={{ width: '100%' }} disabled={!canEditContent || record.lineNum === null}
        />
      ),
    });

    // --- COLUMNAS RESTANTES ---
    baseColumns.push(
      { title: 'Dims', dataIndex: 'dimensions', width: 100, render: (t) => <Input size="small" value={t} disabled /> },
      { title: 'Peso(KG)', dataIndex: 'weight', width: 80, render: (t) => <InputNumber size="small" value={t} disabled /> },
      {
        title: '% Empacado', key: 'packProgress', width: 100, align: 'center',
        render: (_, record) => {
           if (!record.itemCode || !deliveryData?.DocumentLines) return <Tag>N/A</Tag>;
           const line = deliveryData.DocumentLines.find(l => l.ItemCode === record.itemCode && l.LineNum === record.lineNum);
           if(!line || !line.Quantity) return <Tag>N/A</Tag>;
           
           let totalPacked = 0;
           pallets.forEach(p => p.levels.forEach(lvl => lvl.items.forEach(i => {
               if(i.itemCode === record.itemCode && i.lineNum === record.lineNum) totalPacked += (i.quantity || 0);
           })));
           const pct = Math.min(100, Math.floor((totalPacked / line.Quantity) * 100));
           return <Progress percent={pct} size="small" status={pct >= 100 ? 'success' : 'active'} showInfo={false} />;
        }
      },
      {
        title: 'Acción', width: 50, align: 'center',
        render: (_, __, iIdx) => (
            <Button danger icon={<DeleteOutlined />} onClick={() => removeItemFromLevel(palletIdx, levelIdx, iIdx)} size="small" type="text" disabled={!canEditContent} />
        ),
      }
    );

    return baseColumns;
  };

  // +++ INICIO: NUEVAS FUNCIONES PARA MANEJO DE DIMENSIONES MANUALES +++
  const handleDimensionChange = (value, palletIndex) => {
    if (value === 'manual') {
      setEditingPalletIndex(palletIndex);
      setIsManualDimModalVisible(true);
      manualDimForm.resetFields();
    } else {
      updatePalletDetails(palletIndex, 'dimensions', value);
    }
  };

  const handleEditManualDimensions = (palletIndex) => {
    const pallet = pallets[palletIndex];
    if (!pallet || !pallet.dimensions) return;
    const regex = /(?:(Caja)\s)?\(?(\d+)x(\d+)x(\d+)\)?/;
    const match = pallet.dimensions.match(regex);
    if (match) {
      const [, typeStr, length, width, height] = match;
      const type = typeStr ? 'CAJA' : 'TARIMA';
      manualDimForm.setFieldsValue({
        length: Number(length),
        width: Number(width),
        height: Number(height),
        type: type,
      });
      setEditingPalletIndex(palletIndex);
      setIsManualDimModalVisible(true);
    } else {
      message.warn("No se pudieron leer las dimensiones actuales, por favor ingréselas de nuevo.");
      setEditingPalletIndex(palletIndex);
      setIsManualDimModalVisible(true);
      manualDimForm.resetFields();
    }
  };

  const handleManualSave = (values) => {
    const { length, width, height, type } = values;
    let newDimensionsString = `${length}x${width}x${height}`;
    if (type === 'CAJA') {
      newDimensionsString = `Caja (${newDimensionsString})`;
    }
    updatePalletDetails(editingPalletIndex, 'dimensions', newDimensionsString);
    updatePalletDetails(editingPalletIndex, 'type', type);
    setIsManualDimModalVisible(false);
    setEditingPalletIndex(null);
    message.success(`Dimensiones manuales '${newDimensionsString}' asignadas.`);
  };
  // +++ FIN: NUEVAS FUNCIONES +++



  if (loading && !deliveryData) {
    return (
      <div style={{ textAlign: 'center', padding: '50px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 'calc(100vh - 200px)' }}>
        <Spin size="large" />
        <Text style={{ marginTop: 8 }}>Cargando Editor B...</Text>
      </div>
    );
  }

  if (!deliveryData && !loading) { return <Card><Typography.Text type="danger">No se pudieron cargar datos para Editor B.</Typography.Text><Button onClick={handleBack} style={{ marginTop: 16 }}>Volver</Button></Card>; }

  const isEditMode = !!(deliveryData?.packingList?.packingListNumber && deliveryData?.packingList?.formato === 'B');
  const isEvidenceTabVisible = !isEditMode || permissions.canViewEvidence || permissions.canManageEvidenceOnEdit;

  const tabItems = [
    {
      key: 'pallets',
      label: 'Tarimas (B)',
      children: (
        <>
          {pallets.map((pallet, palletIndex) => (
            <Card
              size="small"
              key={`pfs-pallet-${palletIndex}`}
              title={
                <Space>
                  <Button
                    type="text"
                    size="small"
                    icon={pallet.isPalletExpanded ? <DownOutlined /> : <RightOutlined />}
                    onClick={() => togglePalletExpansion(palletIndex)}
                  />
                  <Typography.Text strong style={{ width: 150, display: 'inline-block', verticalAlign: 'middle', lineHeight: '24px' }}>
                    {pallet.palletNumber}
                  </Typography.Text>
                </Space>
              }
              extra={<Popconfirm title="¿Eliminar esta tarima (B)?" onConfirm={() => removePallet(palletIndex)} okText="Sí" cancelText="No" placement="left" disabled={!canEditContent}> <Button size="small" danger icon={<DeleteOutlined />} disabled={!canEditContent}>Eliminar Tarima</Button> </Popconfirm>}
              style={{ marginBottom: 12, body: { padding: pallet.isPalletExpanded ? '8px 12px' : '0px', display: pallet.isPalletExpanded ? 'block' : 'none' } }}
            >
              {pallet.isPalletExpanded && (<>
                <Row gutter={8}>
                  <Col xs={24} sm={12}>
                    <Form.Item label="Dims Tarima" size="small" style={{ marginBottom: 8 }}>
                      <Space.Compact style={{ width: '100%' }}>
                        <Select
                          size="small"
                          value={pallet.dimensions || undefined}
                          placeholder="Seleccionar medida"
                          style={{ width: '100%' }}
                          onChange={(selectedValue) => handleDimensionChange(selectedValue, palletIndex)}
                          allowClear
                          loading={catalogLoading}
                          disabled={!canEditContent || catalogLoading}
                        >
                          <Option key="manual" value="manual" style={{ color: '#1890ff', fontWeight: 'bold' }}>
                            Asignar manualmente...
                          </Option>
                          {activePalletDefinitions.map(def => (
                            <Option key={def._id} value={def.dimensions}>
                              {def.dimensions}
                            </Option>
                          ))}
                        </Select>
                        {pallet.dimensions && !activePalletDefinitions.some(def => def.dimensions === pallet.dimensions) && (
                          <Tooltip title="Editar dimensiones manuales">
                            <Button
                              icon={<EditOutlined />}
                              onClick={() => handleEditManualDimensions(palletIndex)}
                              disabled={!canEditContent}
                            />
                          </Tooltip>
                        )}
                      </Space.Compact>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Form.Item label="Peso Tarima(KG)" size="small" style={{ marginBottom: 8 }}>
                      <InputNumber
                        size="small"
                        min={0}
                        value={pallet.weight}
                        onChange={(value) => updatePalletDetails(palletIndex, 'weight', value)}
                        style={{ width: '100%' }}
                        disabled={!canEditContent}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                {pallet.incompleteBoxWarning && (
                  <Row style={{ marginTop: '0px', marginBottom: '8px' }}>
                    <Col span={24}>
                      <Alert
                        message="Advertencia de Cantidad"
                        description={pallet.incompleteBoxWarning}
                        type="warning"
                        showIcon
                        closable
                        onClose={() => clearPalletIncompleteBoxWarning(palletIndex)}
                      />
                    </Col>
                  </Row>
                )}

                {renderPalletSpecificTotals(pallet)}

                <Divider orientation="left" plain style={{ marginTop: 8, marginBottom: 8 }}>Niveles de la Tarima</Divider>
                {pallet.levels && pallet.levels.map((level, levelIndex) => (
                  <Card type="inner" size="small" key={`level-${palletIndex}-${levelIndex}`} title={<Space> <Button type="text" size="small" icon={level.isExpanded ? <DownOutlined /> : <RightOutlined />} onClick={() => toggleLevelExpansion(palletIndex, levelIndex)} /> <Text strong>{level.levelNumber}</Text> </Space>} style={{ marginTop: 8, marginBottom: 8, backgroundColor: '#fafafa' }} extra={pallet.levels.length > 1 && <Popconfirm title={`¿Eliminar ${level.levelNumber}?`} onConfirm={() => removeLevelFromPallet(palletIndex, levelIndex)} okText="Sí" cancelText="No" disabled={!canEditContent}> <Button icon={<DeleteOutlined />} type="text" danger size="small" disabled={!canEditContent} /> </Popconfirm>} >
                    {level.isExpanded && (
                      <Table
                        dataSource={level.items}
                        rowKey="clientSideId"
                        pagination={false}
                        size="small"
                        bordered
                        columns={getItemTableColumns(palletIndex, levelIndex)}
                        footer={() => (<Button size="small" type="dashed" onClick={() => addItemToLevel(palletIndex, levelIndex)} block icon={<PlusOutlined />} disabled={!canEditContent}> Agregar Artículo a {level.levelNumber} </Button>)}
                      />
                    )}
                  </Card>
                ))}
                <Button type="dashed" onClick={() => addLevelToPallet(palletIndex)} block icon={<AppstoreAddOutlined />} style={{ marginTop: 12 }} disabled={!canEditContent}> Agregar Nivel a {pallet.palletNumber} </Button>
              </>
              )}
            </Card>
          ))}


          {/* <Button size="middle" type="dashed" onClick={addNewPallet} block icon={<PlusOutlined />} style={{ marginTop: 12, height: '40px' }} disabled={!canEditContent}> Agregar Nueva Tarima (B) </Button>
         */}



{/* +++ INICIO: BOTONES DE TARIMAS (ESTILO GRIS) +++ */}
          { (pfsTotals.classification === 'combinado' || (tiposDisponibles.monin || tiposDisponibles.capsula || tiposDisponibles.pastilla)) ? (
            <Row gutter={[8, 8]} style={{ marginTop: 12 }}>
              <Col span={24}><Text strong>Agregar tarimas:</Text></Col>
              <Col span={24}>
                <Space wrap>
                  
                  {/* INSUMOS (Azul) */}
                  {(tiposDisponibles.monin || tiposDisponibles.capsula) && (
                    <Button 
                        size="middle" 
                        type="dashed" 
                        onClick={() => addNewPallet('monin')} 
                        icon={<PlusOutlined />} 
                        style={{ height: '40px', borderColor: '#1890ff', color: '#1890ff', backgroundColor: '#f0f5ff' }}
                        disabled={!canEditContent}
                    >
                      Agregar Tarima Insumos 
                    </Button>
                  )}
    
                  {/* LIMPIEZA (Morado) - */}
                  {tiposDisponibles.pastilla && (
                    <Button 
                        size="middle" 
                        type="dashed" 
                        onClick={() => addNewPallet('pastilla')} 
                        icon={<PlusOutlined />} 
                        style={{ height: '40px', borderColor: '#920AF5', color: '#920AF5', backgroundColor: '#F1E9F7' }}
                        disabled={!canEditContent}
                    >
                       Agregar Tarima Limpieza
                    </Button>
                  )}
    
                </Space>
              </Col>
            </Row>
          ) : (
            <Button size="middle" type="dashed" onClick={() => addNewPallet(null)} block icon={<PlusOutlined />} style={{ marginTop: 12, height: '40px' }} disabled={!canEditContent}>
              Agregar Nueva Tarima (B)
            </Button>
          )}
          {/* +++ FIN: BOTONES DE TARIMAS +++ */}




        </>
      )
    },
    ...(isEvidenceTabVisible ? [{
      key: 'evidence',
      label: `Evidencias (${evidenceImages.length}) (B)`,
      children: (
        <>
          <Row gutter={[16, 16]} style={{ marginBottom: 16 }}> <Col> <Button icon={<CameraOutlined />} onClick={() => setPhotoQrVisible(true)} type="primary" disabled={!canManageEvidence}> Capturar Fotos con Móvil (QR) </Button> </Col> <Col> <Text type="secondary">Las fotos se guardan automáticamente al cerrar la sesión de captura móvil.</Text> </Col> </Row> <List grid={{ gutter: 16, xs: 1, sm: 2, md: 3, lg: 4, xl: 5, xxl: 6 }} dataSource={evidenceImages} locale={{ emptyText: "No hay imágenes de evidencia. Use el botón de captura." }} renderItem={(image, index) => {
            const isSavedInSap = !!image.sapAttachmentAbsoluteEntry;
            let canDeleteThisEvidence;
            let canEditDescription;

            if (isSavedInSap) {
              // Para imágenes YA GUARDADAS:
              // Editar descripción y eliminar dependen del permiso de más alto nivel.
              canEditDescription = !isReadOnly && permissions.canDeleteEvidence;
              canDeleteThisEvidence = !isReadOnly && permissions.canDeleteEvidence;
            } else {
              // Para imágenes NUEVAS (en borrador):
              // Editar y eliminar dependen del permiso general de gestionar.
              canEditDescription = !isReadOnly && canManageEvidence;
              canDeleteThisEvidence = !isReadOnly && canManageEvidence;
            }

            return (
              <List.Item>
                <Card
                  hoverable
                  size="small"
                  cover={<Image alt={image.description || `Evidencia B ${index + 1}`} src={image.imageData} style={{ height: 180, objectFit: 'cover' }} preview={{ mask: <EyeOutlined /> }} onError={(e) => { e.target.src = "https://via.placeholder.com/200x180?text=Error+Img"; console.error("Error loading image", image.imageId); }} />}
                  actions={[
                    <Popconfirm
                      title="¿Eliminar esta imagen de evidencia?"
                      onConfirm={() => { setEvidenceImages(prev => prev.filter(img => img.imageId !== image.imageId)); message.info("Imagen marcada para eliminar. Guarde el listado para confirmar."); }}
                      okText="Sí"
                      cancelText="No"
                      disabled={!canDeleteThisEvidence}
                    >
                      <DeleteOutlined
                        key="delete"
                        style={{ color: canDeleteThisEvidence ? 'red' : 'rgba(0, 0, 0, 0.25)' }}
                      />
                    </Popconfirm>,
                    isSavedInSap ? <Tooltip title={`Subido a SAP (Anexo: ${image.sapAttachmentAbsoluteEntry})`}><CheckOutlined style={{ color: 'green' }} /></Tooltip> : <Tooltip title="Pendiente de subir a SAP"><CloudUploadOutlined /></Tooltip>
                  ]}
                >
                  <Card.Meta
                    title={<Input size="small" placeholder="Descripción de la foto" value={image.description} onChange={(e) => { const newDesc = e.target.value; setEvidenceImages(prev => prev.map(img => img.imageId === image.imageId ? { ...img, description: newDesc } : img)); }} disabled={!canEditDescription} />}
                    description={<Text type="secondary" style={{ fontSize: '11px' }}>ID: {image.imageId || 'N/A'}<br />Tomada: {image.timestamp ? moment(image.timestamp).format('DD/MM/YY HH:mm') : 'N/A'}</Text>}
                  />
                </Card>
              </List.Item>
            );
          }} />
        </>
      )
    }] : [])
  ];


  return (
    <div style={{ padding: '12px' }}>
      {showSuccessModal && <SuccessAnimation folio={savedFolio} onClose={() => setShowSuccessModal(false)} />}
      {showErrorModal && <ErrorAnimation percent={incompletePercent} onClose={() => setShowErrorModal(false)} />}
      <Modal
        title="Asignar Dimensiones Manualmente"
        open={isManualDimModalVisible}
        onCancel={() => setIsManualDimModalVisible(false)}
        onOk={() => manualDimForm.submit()}
        okText="Guardar Dimensiones"
        cancelText="Cancelar"
        destroyOnClose
      >
	  
        <Form form={manualDimForm} layout="vertical" onFinish={handleManualSave} initialValues={{ type: 'TARIMA' }}>
          <Row gutter={16}>
            <Col span={8}><Form.Item name="length" label="Largo (cm)" rules={[{ required: true, message: 'Requerido' }]}><InputNumber min={0} style={{ width: '100%' }} /></Form.Item></Col>
            <Col span={8}><Form.Item name="width" label="Ancho (cm)" rules={[{ required: true, message: 'Requerido' }]}><InputNumber min={0} style={{ width: '100%' }} /></Form.Item></Col>
            <Col span={8}><Form.Item name="height" label="Alto (cm)" rules={[{ required: true, message: 'Requerido' }]}><InputNumber min={0} style={{ width: '100%' }} /></Form.Item></Col>
          </Row>
          <Form.Item name="type" label="Tipo" rules={[{ required: true, message: 'Seleccione un tipo' }]}>
            <Select><Option value="TARIMA">TARIMA</Option><Option value="CAJA">CAJA</Option></Select>
          </Form.Item>
        </Form>
      </Modal>

{/* --- MODAL DE CONFLICTO DE MEZCLA (GARANTIZADO QUE SE VE) --- */}
      <Modal
        open={mixConflict.visible}
        title={<span style={{color: '#fa8c16'}}>⚠️ Sugerencia de Empaque</span>}
        footer={[
          <Button key="ok" type="primary" onClick={() => setMixConflict({ ...mixConflict, visible: false })}>
            Entendido
          </Button>
        ]}
        onCancel={() => setMixConflict({ ...mixConflict, visible: false })}
        centered
        zIndex={2000} // Prioridad alta
      >
        <div style={{ fontSize: '15px' }}>
          <p>Los formatos de estos artículos son diferentes y requieren espacios separados por seguridad.</p>
         {/*  <ul style={{ margin: '15px 0', paddingLeft: '20px' }}>
            <li>Contenido actual del nivel: <b>{mixConflict.current}</b></li>
            <li>Lo que intentaste agregar: <b>{mixConflict.intent}</b></li>
          </ul> */}
          <p>Por favor, utilice la opción <b>"Agregar Nivel"</b> o agregar en una tarima diferente para continuar capturando este artículo</p>
         
         {/*  <p>Por favor, utilizar el botón <b>"Agregar Nivel"</b> para separar los artículos o agregar en una tarima diferente.</p>
        */}
        </div>
      </Modal>
      {isReadOnly && (
        <Alert
          message="MODO SOLO CONSULTA"
          description="Está visualizando este listado de empaque. No se permiten modificaciones."
          type="warning"
          showIcon
          style={{ marginBottom: 16, marginTop: 8 }}
        />
      )}
      {/* +++ INICIO: CÓDIGO A AGREGAR +++ */}
      {deliveryData?.packingList?.deletionStatus === 'eliminado' && (
        <Alert
          message="LISTADO ELIMINADO"
          description="Este listado de empaque se encuentra en la papelera."
          type="error"
          showIcon
          style={{ marginBottom: 16 }}
        />
      )}

      {/* +++ FIN: CÓDIGO A AGREGAR +++ */}
      {pdfErrorAlert && (
        <Alert
          message="Atención"
          description={pdfErrorAlert}
          type="warning"
          showIcon
          closable
          onClose={() => setPdfErrorAlert(null)}
          style={{ marginBottom: 16 }}
        />
      )}

      {saveValidationAlert && (
        <Alert
          message="Error de Validación"
          description={saveValidationAlert}
          type="error"
          showIcon
          closable
          onClose={() => setSaveValidationAlert(null)}
          style={{ marginBottom: 16, marginTop: 8 }}
        />
      )}

      {deliveryData && (<PhotoCaptureQR visible={photoQrVisible} docEntry={docEntry} formatoListado="B" onClose={() => setPhotoQrVisible(false)} onComplete={handlePhotoCaptureComplete} />)}
      <Modal title={<div><CloudUploadOutlined /> Cargando Imágenes a SAP (B)</div>} open={uploadProgressVisible} footer={null} closable={false} centered maskClosable={false} width={400}> <div style={{ textAlign: 'center', padding: '20px 0' }}> <Progress type="circle" percent={totalUploadProgress} status="active" size={120} /> <div style={{ marginTop: 20 }}> <Text strong>{uploadStatus}</Text> <div style={{ marginTop: 15 }}> <Progress percent={currentImageProgress} status="active" strokeColor={{ '0%': '#108ee9', '100%': '#87d068' }} /> <Text type="secondary"> Imagen actual: {currentImageIndex + 1} de {totalImagesToUpload} </Text> </div> </div> </div> </Modal>

      {deliveryData && (
        <Row gutter={16} justify="space-between" align="middle" style={{ marginBottom: 12 }}>
          <Col> <Space> <Button size="small" icon={<ArrowLeftOutlined />} onClick={handleBack}>Volver</Button> <Title level={5} style={{ margin: 0 }}> Entrega {deliveryData.DocNum} (Editor B) {deliveryData.packingList?.packingListNumber && (<Tag color="purple" style={{ marginLeft: 8 }}> Folio: {deliveryData.packingList.packingListNumber} </Tag>)} </Title> </Space> </Col>
          <Col> <Space align="end"> <Affix offsetTop={68}>
            <Card size="small" style={{ body: { padding: '4px 8px' } }}> <Space> <PercentageOutlined />
              <Text strong>Progreso Total:</Text> <Progress percent={overallProgress} size="small" style={{ width: 100 }} />
            </Space> </Card>
          </Affix>
            <Button icon={<CameraOutlined />} onClick={() => setPhotoQrVisible(true)} style={{ height: '32px', position: 'relative', bottom: '10px' }} title={"Capturar evidencias fotográficas (B)"} disabled={!canManageEvidence}> Evidencias </Button>
            <Button type="primary" icon={<SaveOutlined />} onClick={savePackingList} loading={saving} style={{ height: '32px', position: 'relative', bottom: '10px' }} disabled={isReadOnly || !permissions.canSaveOrEdit}> Guardar (B) </Button>
            <Button type="default"
              icon={<PrinterOutlined />}
              onClick={generatePDF}
              loading={printLoading} style={{ height: '32px', position: 'relative', bottom: '10px' }}
              disabled={isReadOnly ||
                !deliveryData.packingList?._id ||
                deliveryData.packingList?.formato !== 'B' ||
                !permissions.canGeneratePdf ||
                deliveryData.packingList?.status === 'draft' ||
                deliveryData.packingList?.deletionStatus !== 'activo'

              }
              title={!deliveryData.packingList?._id || deliveryData.packingList?.status === 'draft' ||
                deliveryData.packingList.formato !== 'B' ? "Guarde el listado B primero" : "Generar PDF (B)"}> Generar PDF </Button>

            <Button
              type="default"
              icon={<FilePdfOutlined />}
              onClick={generateReportByPalletPDF}
              loading={reportByPalletLoading}
              style={{ height: '32px', position: 'relative', bottom: '10px' }}
              disabled={isReadOnly ||
                !deliveryData.packingList?._id ||
                deliveryData.packingList?.formato !== 'B' ||
                !permissions.canGeneratePdf ||
                deliveryData.packingList?.status === 'draft' ||
                deliveryData.packingList?.deletionStatus !== 'activo'
              }
              title={!deliveryData.packingList?._id || deliveryData.packingList?.status === 'draft' ||
                deliveryData.packingList.formato !== 'B' ? "Guarde el listado B primero" : "Generar Reporte por Tarima"}
            >
              Imprimir por Tarima
            </Button>
          </Space> </Col>
        </Row>
      )}

      {deliveryData && (
        <Card style={{ marginBottom: 12, body: { padding: '12px 16px' } }} >
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Row gutter={8}>
                <Col span={24}><Text strong>Cliente:</Text> <Text> {deliveryData.CardName} ({deliveryData.CardCode})</Text></Col>
                <Col span={24} style={{ marginTop: '8px' }}><Text strong>Dirección Envío:</Text> <Text> {deliveryData.Address || deliveryData.ShipToCode || 'N/A'}</Text></Col>
                <Col span={24} style={{ marginTop: '8px' }}><Text strong>Fecha Entrega:</Text> <Text> {moment(deliveryData.DocDate).utc().format('DD/MM/YYYY')}</Text></Col>
              </Row>
              <Divider style={{ marginTop: 12, marginBottom: 12 }} />

              <div style={{ marginBottom: 8 }}>
                <Text strong>Orden de Compra:</Text>
                <Text> {deliveryData?.NumAtCard || 'N/A'}</Text>
              </div>

              <div style={{ marginBottom: 12 }}>
                <Text strong>Comentarios Generales de Entrega:</Text> <Text>{deliveryData.Comments || ''}</Text>
              </div>

              <Form
                key={deliveryData.DocNum}
                form={form}
                layout="vertical"
                size="small"
                initialValues={{
                  comments: (deliveryData?.packingList?.formato === 'B' && deliveryData?.packingList?.comments) || ''
                }}
              >
                <Form.Item name="comments" label="Comentarios (B)" style={{ marginBottom: 0 }}>
                  <Input.TextArea rows={1} placeholder="Comentarios adicionales para B..." disabled={!canEditContent} />
                </Form.Item>
              </Form>
            </Col>
            <Col xs={24} md={12}>
              {renderPfsTotals()}
            </Col>
          </Row>
        </Card>
      )}
      {deliveryData && (
        <Tabs
          defaultActiveKey="pallets"
          size="small"
          style={{ marginTop: 0 }}
          items={tabItems}
        />
      )}
    </div>
  );
};

export default PackingListEditorPFS;
